<template>
	<div :class="containerClass" @click="onWrapperClick">
        <div ref="topbar" class="topbar">
            <!-- IE 2026 10 29 / ODOO-5800 (заказ Игоря 29.10: иконка панели столов — «panel-left» с состоянием открыто/закрыто; «Страницы» в шапке — глиф вкладок): menuOpen — панель списка столов открыта (глиф кнопки столов в шапке следует состоянию, а не клику) -->
            <!-- IE 2026 10 29 / ODOO-5800 (заказ Игоря 29.10: кнопка «закрыть список столов» на месте кнопки шапки — без повторного открытия наведением): hoverLock / hover-unlock — после закрытия списка кнопкой в его заголовке наведение на кнопку шапки не открывает его снова до ухода мыши -->
            <AppTopBar @menu-toggle="onMenuToggle" :layoutMode="layoutMode" :menuOpen="sidebarOpen" :hoverLock="sidebarHoverLock" @hover-unlock="sidebarHoverLock = false" @layout-change="onLayoutChange" />
            <!-- IE 2026 09 26 / ODOO-… (замечание Игоря: баннер предупреждения стола): предупреждение страницы (PAGE.notification —
                 бэк, workspaces.check_tasks: «ключевые задачи ещё не рассчитаны») — компактный баннер по центру под шапкой, форма и место как у плашки новой версии,
                 жёлтый; ✕ скрывает его до перезагрузки вкладки (ключ «стол | статус | текст»). Ряд живёт в .topbar, как прежняя полоса: его высота входит в низ
                 шапки — поле виджетов (MainArea) начинается ниже, плашка новой версии встаёт под ним (topBanners_layout). Прежняя полоса во всю ширину —
                 fe.ux.wsAlertBanner = false и мобильный профиль -->
            <div v-if="wsAlert" class="ws-alert-row">
                <!-- IE 2026 09 27 / ODOO-… (заказ Игоря: Open task в баннере предупреждения стола): vars.openTask — строка How и настройка кнопки в объяснении баннера -->
                <div class="ws-alert-banner" :class="'ws-alert-' + wsAlert.status" role="status"
                    v-uiHelp="{ key: 'topbar.pageNotice', vars: () => ({ banner: true, text: wsAlert ? wsAlert.text : '', openTask: wsAlertTasks.length > 0 }) }">
                    <i class="pi pi-exclamation-triangle ws-alert-icon"></i>
                    <span class="ws-alert-text">{{ wsAlert.text }}</span>
                    <!-- IE 2026 09 27 / ODOO-… (заказ Игоря: Open task в баннере предупреждения стола): задача, из-за которой висит
                         предупреждение (check-task строки страницы в doc.pages стола), — открыть её запись на текущей странице, как пункт панели задач;
                         выключатель fe.ux.wsAlertOpenTask; кому — как панель задач (fe.ux.tasksPanelAllUsers) -->
                    <button v-if="wsAlertTasks.length" type="button" class="ws-alert-open" @click="wsAlert_openTask"
                        v-uiHelp="{ key: 'topbar.pageNotice.openTask', vars: () => ({ many: wsAlertTasks.length > 1, tasks: wsAlertTasksNames }) }">
                        <i class="pi ie-ico-tasks-panel"></i>
                        <span>{{ wsAlertTasks.length > 1 ? t('Open tasks ({n})', { n: wsAlertTasks.length }) : t('Open task') }}</span>
                    </button>
                    <button type="button" class="ws-alert-close" :title="t('Hide the warning')" @click="wsAlert_close" v-uiHelp="'topbar.pageNotice.close'">
                        <i class="pi pi-times"></i>
                    </button>
                </div>
            </div>
            <div v-else-if="PAGE?.notification?.visible && !wsAlertBannerOn" class="notification-workspace" v-uiHelp="'topbar.pageNotice'" :class="{
                'notification-warning': PAGE.notification.status=='warning',
                'notification-info': PAGE.notification.status=='info', /* IE 2026 11 02 / ODOO-349799 (toast-info) */
                'notification-error': PAGE.notification.status=='error',
                'notification-critical': PAGE.notification.status=='critical',
                'notification-pending': PAGE.notification.status=='pending',
            }">
                {{ PAGE.notification.header }} {{ PAGE.notification.text }}
            </div>
        </div>
        <div class="layout-sidebar" 
            @click="onSidebarClick"
            @mouseleave="handleMouseLeave"
        >
            <!-- ODOO-3749: напрямую из store — снапшот ссылки в setup() переставал
                 видеть меню после пересборки (setup присваивает НОВЫЙ массив) -->
            <!-- IE 2026 08 20 / ODOO-336291 (mobile UX) (заказ Игоря): сайдбар компонентами рейла — RailMenu -->
            <!-- IE 2026 10 29 / ODOO-5800 (заказ Игоря 29.10: кнопка «закрыть список столов» на месте кнопки шапки — панель в overlay накрывает шапку): @close — кнопка закрытия в заголовке списка -->
            <RailMenu :model="store.menuTree_model" @menuitem-click="onMenuItemClick" @close="onSidebarClose" />
        </div>

        <div :class="mainContainer" :style="mainContainerStyle">
            <router-view v-slot="{ Component }">
                <transition>
                    <!-- pmKeepView: process_model в ключе НЕ участвует — смена модели
                         через router.replace не должна перемонтировать всё дерево
                         (стол сохраняет вид, обновляются только данные) -->
                    <keep-alive>
                        <component :is="Component" :key="routeViewKey" />
                    </keep-alive>
                </transition>
            </router-view>
        </div>

        <transition name="layout-mask">
            <div class="layout-mask p-component-overlay" v-if="mobileMenuActive"></div>
        </transition>

        <!-- ODOO-3705: инициализация целевой базы занимает секунды. Без блокирующей
             индикации пользователь продолжает работать, считая, что он ещё в прежней
             базе. Снимается в router.afterEach и по таймауту-страховке в store. -->
        <div v-if="store?.dbSwitching" class="db-switching" v-uiHelp="'topbar.dbSwitching'">
            <div class="db-switching-box">
                <i class="pi pi-spin pi-spinner db-switching-icon"></i>
                <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                <div class="db-switching-title">{{ t('Switching database') }}</div>
                <div class="db-switching-db">{{ store.dbSwitching.title }}</div>
                <div class="db-switching-note">{{ t('The previous database is already closed — please wait for it to load.') }}</div>
            </div>
        </div>

        <!-- IE 2026 08 23 / ODOO-5884 (заказ Игоря): подтверждение с полем ввода (имя создаваемой ветки) -->
        <div v-if="store?.confirmInput.visible" class="progress-modal" @click.self="store.confirmInput_cancel">
            <div class="progress-box confirm-input-box" v-uiHelp="'topbar.confirm'">
                <div class="progress-header">{{ store.confirmInput.header }}</div>
                <div class="confirm-input-message">{{ store.confirmInput.message }}</div>
                <div class="confirm-input-field">
                    <label class="confirm-input-label">{{ store.confirmInput.label }}<span v-if="store.confirmInput.required" class="confirm-input-req"> *</span></label>
                    <input type="text" :class="['confirm-input-input', store.confirmInput.invalid && store.confirmInput.required && !(store.confirmInput.value || '').trim() ? 'is-invalid' : '']" v-model="store.confirmInput.value"
                        @input="store.confirmInput.invalid = false"
                        @keydown.enter.prevent="store.confirmInput_accept" @keydown.esc.prevent="store.confirmInput_cancel" />
                </div>
                <!-- IE 2026 08 24 / ODOO-5884 (заказ Игоря «частичная полная версия»): чекбоксы состава полного копирования -->
                <!-- IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FE1-app FE1: поле даты окна (Set due согласования) -->
                <div v-if="store.confirmInput.date" class="confirm-input-date">
                    <label class="confirm-input-label">{{ store.confirmInput.date.label }}</label>
                    <input type="date" class="confirm-input-input" v-model="store.confirmInput.date.value" />
                </div>
                <div v-if="store.confirmInput.options?.length" :class="['confirm-input-options', store.confirmInput.invalid && store.confirmInput.optionsRequired && !store.confirmInput.options.some(x => x.checked) ? 'is-invalid' : '']">
                    <label v-for="(o, oi) in store.confirmInput.options" :key="oi" class="confirm-input-option">
                        <input type="checkbox" v-model="o.checked" @change="store.confirmInput_pick(oi)" /> {{ o.label }}
                    </label>
                </div>
                <!-- IE 2026 10 09 / ODOO-345618 (заказ Игоря: согласование на сегменте): обязательное поле не заполнено -->
                <div v-if="store.confirmInput.invalid" class="confirm-input-err">{{ t('Fill in the required fields') }}</div>
                <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                <div class="confirm-input-actions">
                    <button class="cinp-btn cinp-btn-no" @click="store.confirmInput_cancel" v-uiHelp="'topbar.confirm'">{{ t('No') }}</button>
                    <button class="cinp-btn cinp-btn-yes" @click="store.confirmInput_accept" v-uiHelp="'topbar.confirm'">{{ t('Yes') }}</button>
                </div>
            </div>
        </div>

        <!-- IE 2026 08 23 / ODOO-5884 (заказ Игоря): команда с confirm + progress (Create/Discard branch): после Yes
             окно подтверждения сменяется окном прогресса без кнопок (полоса Loading как у виджета), закрывается по ответу -->
        <div v-if="store?.progress.visible" class="progress-modal">
            <div class="progress-box" v-uiHelp="'topbar.progress'">
                <div class="progress-header">{{ store.progress.header }}</div>
                <div class="progress-loading-bar"></div>
                <div class="progress-text">
                    <i class="pi pi-spin pi-spinner progress-icon"></i>
                    <span>{{ store.progress.text }}</span>
                </div>
                <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                <div class="progress-note">{{ t('Loading…') }}</div>
            </div>
        </div>

        <div v-if="store?.notification.visible" class="notification" v-uiHelp="{ key: 'topbar.toast', state: () => (store.notification.status) }" :class="{
                'notification-fade-out': store.notification.fading,
                'notification-warning': store.notification.status=='warning',
                'notification-info': store.notification.status=='info', /* IE 2026 11 02 / ODOO-349799 (toast-info) */
                'notification-error': store.notification.status=='error',
                'notification-critical': store.notification.status=='critical',
                'notification-pending': store.notification.status=='pending',
            }"
            @mouseover="store.restore_notification" @mouseout="store.fadeOut_notification">
            <!-- IE 2026 08 26 / ODOO-5800 (заказ Игоря): ход выполнения прогона — полоса над текстом тоста
                 (как полоса загрузки виджета задачи); progress null — полосы нет -->
            <div v-if="store.notification.progress != null" class="notification-progress" v-uiHelp="'topbar.toast.progress'" :title="store.notification.progress + '%'">
                <div class="notification-progress-bar" :style="{ width: Math.max(2, Math.min(100, store.notification.progress)) + '%' }"></div>
            </div>
            <!-- <div class="notification-header">{{ store?.truncateText(store.notification.header,100) }}</div> <br> -->
            {{ store?.truncateText(store.notification.text, 150) }}
            <!-- IE 2026 08 23 / ODOO-5884 (заказ Игоря): кликабельная ссылка тоста (напр. «Open log») -->
            <!-- IE 2026 09 23 / ODOO-341407: i18n -->
            <a v-if="store.notification.action" class="notification-link ml-2" v-uiHelp="'topbar.toast.link'" :title="store.notification.action.tooltip || store.notification.action.title || ''"
                @click.stop="store.notification_action_open">
                <i class="pi pi-external-link mr-1"></i>{{ store.notification.action.title || t('Open') }}
            </a>
            <div class="button ml-2 btn-hover" :title="t('Close notification')" v-uiHelp="'topbar.toast.close'" @click="store.close_notification(true)">
                <i class="pi pi-times"></i>
            </div>
        </div>

        <!-- вкладка работает на устаревшем бандле: сервер отдаёт другую версию.
             Не блокирует работу — рекомендация с кнопкой перезагрузки -->
        <div v-if="store?.version_outdated" class="update-banner" :style="{ '--update-banner-top': updateBannerTop }" v-uiHelp="'topbar.updateBanner'">
            <i class="pi pi-refresh update-banner-icon"></i>
            <!-- IE 2026 09 23 / ODOO-341407: i18n -->
            <span class="update-banner-text">
                {{ t('A new version is available ({served}). This tab still runs {current} — reload to update.', { served: store.version_frontend_served, current: store.version_frontend }) }}
            </span>
            <button class="update-banner-btn" :title="t('Reload the page')" @click="reloadForUpdate" v-uiHelp="'topbar.updateBanner.reload'">
                <i class="pi pi-refresh"></i>&nbsp;{{ t('Reload') }}
            </button>
            <!-- IE 2026 08 27 (Igor): крестика нет — плашку нельзя скрыть, на любом скрине видно, что версия устарела -->
        </div>

        <!-- индикатор записи тестового сценария: всегда виден, пока идёт запись -->
        <div v-if="store?.testRecording?.active" class="rec-indicator" v-uiHelp="'topbar.rec'">
            <span class="rec-dot"></span>
            <!-- IE 2026 09 23 / ODOO-341407: i18n -->
            <span class="rec-text">{{ tn(store.testRecording.events.length, 'Recording… {n} event', 'Recording… {n} events') }}</span>
            <button class="rec-stop" :title="t('Stop recording')" @click="stopTestRecording" v-uiHelp="'topbar.rec.stop'">
                <i class="pi pi-stop-circle"></i>&nbsp;{{ t('Stop') }}
            </button>
        </div>

        <!-- IE 2026 09 11 / ODOO-335246 (Igor): пошаговая отладка каскада — один шаг лаунчера за клик (подготовка прохода /
             одна стадия / завершение прохода); показывает, что сделал предыдущий шаг (узлы, задачи, время) и что сделает следующий -->
        <div v-if="store?.cascadeDebug?.on && store.user?.rights?.['access-admin']" class="casc-debug">   <!-- IE 2026 09 12 (Igor): только администраторам базы -->
            <!-- IE 2026 09 23 / ODOO-341407: i18n -->
            <button class="casc-debug-run" :disabled="store.cascadeDebug.busy" v-uiHelp="'topbar.cascade.run'" :title="t('Run exactly one cascade step: prepare the pass, one stage, or finish the pass')" @click="store.cascadeDebug_step()">
                <i :class="store.cascadeDebug.busy ? 'pi pi-spin pi-spinner' : 'pi pi-step-forward'"></i>&nbsp;{{ t('Run debug iteration') }}
            </button>
            <div class="casc-debug-info">
                <div class="casc-debug-row casc-debug-err" v-if="store.cascadeDebug.last?.error">{{ store.cascadeDebug.last.error }}</div>
                <!-- IE 2026 09 11 (Igor): описание шага — ссылка в лог (стадии — её лог, иначе лог прогона) -->
                <div class="casc-debug-row"><b>{{ t('Last step:') }}</b>
                    <a v-if="store.cascadeDebug_logRef()" class="casc-debug-link" href="#" :title="t('Open the log record of this step')" v-uiHelp="'topbar.cascade.lastStep'" @click.prevent="store.cascadeDebug_openLog()">{{ store.cascadeDebug.last?.prev?.text || '—' }}</a>
                    <template v-else>{{ store.cascadeDebug.last?.prev?.text || '—' }}</template>
                </div>
                <div class="casc-debug-row"><b>{{ t('Next step:') }}</b> {{ store.cascadeDebug.last?.next?.text || '—' }}</div>
            </div>
            <button class="casc-debug-off" :title="t('Turn cascade debug off (auto-recalculation resumes)')" v-uiHelp="'topbar.cascade.off'" @click="store.cascadeDebug_toggle()"><i class="pi pi-times"></i></button>
        </div>

        <ConfirmDialog />
        <Dropdown ref="dropdown" />
        <I18nTitles ref="i18nCard" /> <!-- IE 2026 09 24 / ODOO-341407 (заказ Игоря): карточка «Translations» — одна на приложение (store.i18nCard) -->
        <I18nSwitchProgress /> <!-- IE 2026 09 25 / ODOO-341407 (замечание пользователей: не видно, когда переключение языка выполнено полностью): ход переключения -->
        <MfaSecurityDialog /> <!-- Odoo 350042: окно «Sign-in security» из меню пользователя -->
        <RecordHelpDialog /> <!-- IE 2026 09 25 / ODOO-… (замечание Игоря: многострочный диалог описания записи): диалог правки объяснения записи — один на приложение (recordHelp.dialog) -->
        <HelpCard v-if="helpCardOn" /> <!-- IE 2026 11 03 / ODOO-350881 (инвентаризация помощи, этап 1): карточка помощи окна — одна на приложение (helpCard.card), только при флаге fe.ux.helpCard -->
        <Search ref="globalSearch" command="globalSearch" />
        <Search ref="globalHistory" command="globalHistory" />
        <Search ref="globalJob" command="globalJob" />
        <Search ref="globalLog" command="globalLog" />
        <AltTabSwitcher /> <!-- IE 2026 09 08 / ODOO-… (заказ Игоря): Alt+Tab — лист виджетов по центру экрана -->
        <FreeWidgetsStrip /> <!-- IE 2026 09 08 / ODOO-… (заказ Игоря): полоса парковки свободных виджетов + CSS режимов -->
        <GuideBar /> <!-- IE 2026 09 28 / ODOO-342342 (Use cases): полоса показа кейса / пути — после «Open in demo» / «Start path» (store.guideSession) -->
        <NavigatorDock /> <!-- demo-webscm 2026 11 02 / ODOO-350612: навигатор интерфейса — правый док / вільне вікно / смужка (store.navigator) -->
        <ApprovalHistory /> <!-- IE 2026 10 09 / ODOO-345618 (F2): окно «History» единицы согласования — одно на приложение (store.approvalHistory) -->
    </div>
</template>

<script>
import AppTopBar from './AppTopbar.vue';
// import ControlPanel from './ControlPanel.vue';
import AppMenu from './AppMenu.vue';
import RailMenu from './RailMenu.vue'; // IE 2026 08 20 / ODOO-336291 (mobile UX)
import { useMainStore } from './stores/mainStore'
import { topbarBottom_px } from './utils/topbarMargin'   // IE 2026 11 01 / ODOO-350597: низ шапки — реактивно в store.topbarBottom (рейл страницы без раскладки)
// import AppFooter from './AppFooter.vue';
import { Tooltip } from '@mescius/wijmo'
import { shownTip_defer, shownTip_hoverOn } from './utils/shownTitle'   // IE 2026 10 04 / ODOO-5800 (fe-72): подсказка бэка ячейки с показанным текстом — по наведению всегда
import altTooltip from './utils/altTooltip' // IE 2026 09 07 / ODOO-337259: зажатый Alt — мгновенная подсказка элемента под мышью
import nativeTitles from './utils/nativeTitles' // IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции): нативные title → aria-label, показ по Alt / в режиме Show tooltips
import tipActions from './utils/tipActions' // IE 2026 09 23 / ODOO-… (заказ Игоря: кнопки в подсказках): кнопки-действия в подсказках (открыть / ссылка / новая вкладка / вставить), клики, удержание
import recordHelp from './utils/recordHelp' // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2: объяснения записей в подсказках (транспорт record_help, кэш, «Edit description»)
import { overlayRoot } from './utils/overlayRoot' // IE 2026 09 23 / ODOO-… (замечание Игоря: панели-меню в Full screen): подсказка переносится только в полноэкранный ВИДЖЕТ
import altTab from './utils/altTab' // IE 2026 09 08 / ODOO-… (заказ Игоря): Alt+Tab — переключатель виджетов страницы
import { escKeepGridFocus_on, escKeepGridFocus_dirty, escKeepGridFocus_decide, escKeepGridFocus_apply } from './utils/escKeepGridFocus' // IE 2026 10 14 / ODOO-5800: Escape в гриде без редактора при правках — фокус остаётся на гриде (Ctrl+Z работает), виджет не закрывается
import AltTabSwitcher from './components/AltTabSwitcher.vue' // IE 2026 09 08 / ODOO-…: лист виджетов по центру экрана
import I18nTitles from './components/widgets/components_core/I18nTitles.vue' // IE 2026 09 24 / ODOO-341407: карточка «Translations» (названия на трёх языках)
import I18nSwitchProgress from './components/I18nSwitchProgress.vue' // IE 2026 09 25 / ODOO-341407: индикатор хода живого переключения языка
import MfaSecurityDialog from './components/MfaSecurityDialog.vue' // Odoo 350042
import HelpCard from './components/HelpCard.vue' // IE 2026 11 03 / ODOO-350881 (инвентаризация помощи, этап 1): карточка помощи окна
import { helpCard_on } from './utils/helpCard' // IE 2026 11 03 / ODOO-350881: флаг fe.ux.helpCard
import RecordHelpDialog from './components/RecordHelpDialog.vue' // IE 2026 09 25 / ODOO-… (замечание Игоря: многострочный диалог описания записи)
import freeWidgets from './utils/freeWidgets' // IE 2026 09 08 / ODOO-… (заказ Игоря): поведение свободных виджетов при активном докированном
import FreeWidgetsStrip from './components/FreeWidgetsStrip.vue' // IE 2026 09 08 / ODOO-…: полоса парковки + CSS режимов
import NavigatorDock from './components/NavigatorDock.vue' // demo-webscm 2026 11 02 / ODOO-350612: правый док навигатора интерфейса
import { navigator_reserve, navigator_areaRescaleX } from '@/utils/navigator'   // demo-webscm 2026 11 02 / ODOO-350612: место справа под док / смужку; свободные виджеты — по свободной области
import GuideBar from './components/GuideBar.vue' // IE 2026 09 28 / ODOO-342342 (Use cases): полоса показа кейса / пути
import ApprovalHistory from './components/ApprovalHistory.vue' // IE 2026 10 09 / ODOO-345618 (заказ Игоря: согласование на сегменте, F2): окно «History» единицы согласования (answer.approval_history)
import { tasksPanel_openAction } from './utils/tasksPanel' // IE 2026 09 27 / ODOO-… (заказ Игоря: Open task в баннере предупреждения стола): действие открытия задачи — как у пункта панели задач
import { wsAlertTasks_of, wsAlertTasks_items, wsAlertTasks_names, wsAlertTasks_fromTitles } from './utils/wsAlertTask' // IE 2026 09 27 / ODOO-… (заказ Игоря: Open task в баннере предупреждения стола): задачи предупреждения страницы
import { getLanguage } from './i18n' // IE 2026 09 27 / ODOO-… (заказ Игоря: Open task в баннере предупреждения стола): язык кэша названий задач баннера
import { activityPing_start } from './utils/activityPing' // IE 2026 11 03 / ODOO-350449 (activity ping): пинг активности вкладки раз в минуту (fe.activity.ping)
import { widgetPreviews_start } from './utils/widgetPreviews' // IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов): планировщик автосъёмки, консоль window.widgetPreviews

const _routeReopenMemo = {}   // IE 2026 09 26 / ODOO-… (замечание Игоря: «+» на новой странице): номер пересборки стола, уже вошедший в ключ страниц (routeReopenSuffix)
let showTooltip = null
const originalShow = Tooltip.prototype.show
Tooltip.prototype.show = function(...args) {
    const store = useMainStore(),
    mouseX = store.mouseX,
    mouseY = store.mouseY
    let [refEl, content, rect] = args

    // IE 2026 10 12 / ODOO-5800 (замечание Игоря, скрин 12.10): лист Alt+Tab открыт только при зажатом Alt, и каждое наведение на его строку
    // поднимало карточку объяснения (Alt-подсказка) поверх списка. Внутри панели переключателя подсказок нет: ключи и смысл блоков
    // объясняет строка-подсказка внизу панели; объяснения uiHelp (topbar.alttab.*) остаются в реестре
    try { if (refEl?.closest?.('.alt-tab-panel')) return } catch (e) { /* refEl может быть не элементом */ }
    // IE 2026 09 07 / ODOO-337259: при зажатом Alt показом управляет altTooltip (внутренний элемент важнее
    // внешнего: кнопка, а не виджет) — штатные mousemove-показы wijmo в это время глушим
    if (altTooltip.held && !altTooltip.showing) return
    // IE 2026 09 07 / ODOO-337259: «ленивая» подсказка (v-wjTooltipFn) — контент считается в момент показа;
    // показ при включённом Show tooltips или при зажатом Alt
    const tipFn = refEl?.__wjTipFn
    if (tipFn && !altTooltip.showing) {
        if (!store.showTooltip && !altTooltip.held) return
        content = altTooltip.resolve(tipFn)
        if (!content) return
        args = [refEl, content, rect, args[3]]
    }
    // IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции): статичная подсказка по наведению (v-wjTooltip / setTooltip — показ wijmo по наведению или фокусу элемента,
    // зарегистрированного в ЭТОМ инстансе) без зажатого Alt, вне режима Show tooltips и без fe.ux.hoverTooltips — не показывается; показ нашего
    // контроллера (altTooltip.showing) и ручные show() без регистрации (подсказки данных графиков wijmo, карточка шапки грида — свой затвор) идут как раньше
    // IE 2026 10 04 / ODOO-5800 (fe-72) (замер dev02_check24: у ячеек Signal / Reason грида Metrics wijmo звал show() с текстом бэка, а этот затвор его гасил — подсказки не было):
    // ячейка грида с показанным текстом `<binding>-title` (отметка __shownTip, AttrGrid.shownTitle_cellApply) показывает подсказку бэка по наведению ВСЕГДА — через 1,5 с покоя
    // курсора в ячейке (shownTip_defer; wijmo зовёт show() на каждый mousemove без задержки). Остальные статичные подсказки — как раньше. Выключатель fe.grid.shownTitle
    if (!altTooltip.showing && refEl && refEl.__wjTipInst === this && !altTooltip.explainOn()) {
        // IE 2026 10 16 / ODOO-5800: отложенный показ по наведению — только при fe.ux.shownTipHover=true (дефолт ВЫКЛ, правило Игоря «подсказки только по Alt или опции»); выкл — та же подсказка идёт как все статичные (по Alt / Show tooltips)
        if (refEl.__shownTip && store.setting('fe.grid.shownTitle', true) !== false && shownTip_hoverOn(store)) {
            if (!refEl.__shownTipPass) { shownTip_defer(this, refEl, () => { if (altTooltip.held || altTooltip.showing) return false; altTooltip.lastKey = null; return true }); return }
        } else { altTooltip.stats.hoverGated++; return }
    }

    // ключ: контент + координаты (можно укоротить)
    const key = `${content}__${rect?.left}|${rect?.top}|${rect?.width}|${rect?.height}`
    if (key === altTooltip.lastKey) {
        return
    }
    altTooltip.lastKey = key

    // console.log(mouseX)

    // if (showTooltip) { clearTimeout(showTooltip) }
    // showTooltip = setTimeout(() => {
        // if (mouseX === store.mouseX && mouseY === store.mouseY
        // && !store?.params_dragSource?.type
        // // && !store.dataTransfer 
        // ) {
            const result = originalShow.apply(this, args)
            tipActions.shown(this)   // IE 2026 09 23 / ODOO-… (заказ Игоря: кнопки в подсказках): инстанс показа — им подсказка прячется после действия
        
            if (!this.showDelay) { // not is AttrChart
                this.gap = 50
            }
            this.hideDelay = 0

            // if (this.showTooltipFast || store.showTooltipFast) {
                this.showDelay = store.setting('fe.ux.tooltipShowDelayMs', 400)   // IE 2026 09 05 / ODOO-336330
            // } else {
            //     this.showDelay = 3000
            // }
            
            
            // this.showAtMouse = false
            store.tooltip_attachListeners(content)
            
            this.cssClass = 'wj-tooltip-my'

            // ---- ВАЖНО: перемещаем tooltip при fullscreen
            requestAnimationFrame(() => {
                const tooltipEl = document.querySelector('.wj-tooltip')
                const fsEl = overlayRoot()   // IE 2026 09 23 / ODOO-… (замечание Игоря: панели-меню в Full screen): полноэкран всего документа — подсказка остаётся в body
                
                if (tooltipEl && fsEl !== document.body) {
                    // console.log("Tooltip inside fullscreen")
                    // переносим tooltip внутрь fullscreen-виджета
                    if (!fsEl.contains(tooltipEl)) {
                        fsEl.appendChild(tooltipEl)
                    }

                    // обязательно позиционирование
                    tooltipEl.style.position = 'absolute'
                    tooltipEl.style.zIndex = 3000

                }
            })

        // }
    // }, 1000)    

    return result
}

export default {
    emits: ['change-theme'],
    data() {
        return {
            layoutMode: 'overlay',
            staticMenuInactive: false,
            sidebarHoverLock: false,   // IE 2026 10 29 / ODOO-5800 (заказ Игоря 29.10: кнопка «закрыть список столов» на месте кнопки шапки — без повторного открытия наведением): после закрытия кнопкой в заголовке списка курсор на кнопке шапки — наведение не открывает список (снимает @hover-unlock)
            overlayMenuActive: false,
            mobileMenuActive: false,
            resizeTimeout: null,
            scrollTimeout: null,
            updateBannerTop: '52px',   // IE 2026 08 27: плашка версии — сразу под шапкой (меряется при показе)
            wsAlertClosed: {},   // IE 2026 09 26 / ODOO-… (замечание Игоря: баннер предупреждения стола): скрытые ✕ предупреждения — ключ «стол | статус | текст» → время; до перезагрузки вкладки
            wsAlertTaskInfo: {},   // IE 2026 09 27 / ODOO-… (заказ Игоря: Open task в баннере предупреждения стола): названия и сегменты задач баннера — ответ catalog_titles по ключу «язык|id» (записи нет — { miss: true })
        }
    },
    setup() {
        const store = useMainStore()

        return {
            store,
        }
    },
    created() {
        this.store.App = this
    },
    mounted() {
        const store = this.store
        store.div_topbar = this.$refs.topbar
        store.topbarBottom = topbarBottom_px(store.div_topbar)   // IE 2026 11 01 / ODOO-350597
        // IE 2026 09 11 / ODOO-335246 (Igor): режим отладки каскада пережил перезагрузку — подтянуть состояние шага
        if (store.cascadeDebug?.on) setTimeout(() => { try { store.cascadeDebug_call('state') } catch (e) { /* бэк ещё не готов */ } }, 4000)

        this._prevW = window.innerWidth - this.navReserve   // demo-webscm 2026 11 02 / ODOO-350612: ширина свободной области (без дока навигатора), не экрана
        this._prevH = window.innerHeight

        window.addEventListener('resize', this.resize)
        window.addEventListener('scroll', this.scroll)

        this._topbarResizeObserver = new ResizeObserver(() => this.resize())
        this._topbarResizeObserver.observe(this.$refs.topbar)

        this.resize()
        store.version_check_start() // сверка версии вкладки с выложенной
        store.autoRecalc_poll_start() // IE 2026 08 24 / ODOO-5884: поллинг авто-пересчёта по триггерам
        activityPing_start(store) // IE 2026 11 03 / ODOO-350449 (activity ping): видимая вкладка с вводом за 2 мин → executeBackendMethod activity_ping (work.logs LOGS-activity)
        widgetPreviews_start(store) // IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов): автосъёмка отсутствующих картинок в простое (fe.ux.widgetPreviewAuto), опрос методов бэка
        // IE 2026 08 24 / ODOO-5884: консольный выключатель авто-пересчёта (правило «оптимизации через
        // переключаемые опции», дефолты ВКЛ): window.autoRecalc.get()/.set('enabled', false)/.reset()
        window.autoRecalc = {
            get: () => ({ ...store.autoRecalc }),
            set: (k, v) => { store.autoRecalc[k] = v; localStorage.setItem('autoRecalc', JSON.stringify(store.autoRecalc)); return { ...store.autoRecalc } },
            reset: () => { localStorage.removeItem('autoRecalc'); return 'reload the page to apply defaults' },
        }
        store.dropdown = this.$refs.dropdown // store.WIDGETS.dropdown
        store.i18nCard = this.$refs.i18nCard   // IE 2026 09 24 / ODOO-341407: карточка «Translations» (store.i18n_card_open)
        store.globalSearch = this.$refs.globalSearch
        store.globalHistory = this.$refs.globalHistory
        store.globalJob = this.$refs.globalJob
        store.globalLog = this.$refs.globalLog

        this.handleKeydown = (event) => {
            const hotkey = this.store.normalizeHotkey(event);
            // console.log('Keydown', hotkey)

            // ⚠ Открыт оверлей верхнего уровня — ВСЕ глобальные хоткеи приложения молчат:
            //   .p-dialog-mask   — маска модального PrimeVue <Dialog modal>
            //                      ('Debug backend', 'Databases — admin info', …)
            //   .db-picker-popup — поп-ап выбора базы (AppTopbar)
            // Виджет под оверлеем неактивен, и Escape обязан закрывать сам оверлей,
            // а не виджет под ним (баг 2026-07-29). Этот слушатель висит в
            // CAPTURE-фазе и глушит событие, поэтому без раннего выхода
            // bubble-обработчики оверлеев (Dialog.onKeyDown, _dbPickerKeydown)
            // не получают Escape вовсе — оверлей не закрывался ничем, а Esc уходил
            // в виджет под ним.
            // Добавляя новый оверлей со своим Escape — дописывай его сюда.
            //   .rh-dialog-mask  — диалог описания записи (RecordHelpDialog; IE 2026 09 25 / ODOO-… (замечание Игоря: многострочный диалог описания записи))
            //   .appr-hist-modal — окно History единицы согласования (ApprovalHistory; IE 2026 10 09 / ODOO-345618, F2): свой Escape закрывает только окно, а не виджет под ним
            //   .ra-form-modal   — окно «Approval» формы правила MAP-* (RuleApprovalForm; IE 2026 11 03 / ODOO-5800 (ie-dm7 #128579: согласование правил MAP-*, этап C — правки пробы p246)): свой Escape закрывает только окно
            if (document.querySelector('.p-dialog-mask, .db-picker-popup, .rh-dialog-mask, .appr-hist-modal, .ra-form-modal')) return   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128579: согласование правил MAP-*, этап C — правки пробы p246): + .ra-form-modal
            // IE 2026 11 03 / ODOO-350449 (проба p254: S2 — цвет только «Непокрито», прокручиваемая часть, Esc фокуса не закрывает виджет): фокус дерева грида активен (fe.ux.treeLevelStyle=focus, класс tls-focus-on хоста) — Esc снимает фокус в гриде
            // (AttrGrid.tls_key, слушатель хоста), а не закрывает виджет; Alt+Esc и Esc без фокуса — как раньше
            if (event.key === 'Escape' && !event.altKey && event.target?.closest?.('.tls-focus-on')) return   // IE 2026 11 03 / ODOO-350449 (проба p254: S2 — цвет только «Непокрито», прокручиваемая часть, Esc фокуса не закрывает виджет)

            // IE 2026 09 08 / ODOO-… (заказ Игоря): Alt+Tab — лист видимых виджетов страницы, Tab при зажатом
            // Alt двигает выделение, отпускание Alt активирует выбранный; пока лист открыт — Esc/Tab/Alt-сочетания его
            // (true = событие съедено: Tab не уходит в грид и не двигает фокус)
            if (altTab.onKeyDown(event)) return

            // prevent Mac Alt special characters (ƒ, ÷, µ, etc.) from being inserted into grids/inputs
            if (event.altKey && !event.ctrlKey && !event.metaKey && event.code?.startsWith('Key')) {
                event.preventDefault()
            }

            if (event.key === "F3") {
                const activeElement = document.activeElement

                let searchValue = ""
                if (activeElement) {
                    if (activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA") {
                        searchValue = activeElement.value
                    } else if (activeElement.isContentEditable) {
                        searchValue = activeElement.innerText
                    } else if (activeElement.classList.contains("wj-cell")) {
                        searchValue = activeElement.textContent.trim()
                    }
                }

                // ODOO-4334: Shift+F3 — «кто ссылается на этот объект». Из ячейки
                // ссылки текст брать НЕЛЬЗЯ: в ячейке нарисован титул, а граф знает
                // только id (dataMap подменяет отображение, col.binding хранит id).
                // Поэтому для графа подставляем сырое значение ячейки.
                if (event.shiftKey) {
                    // webscm 2026 10 25 / ODOO-4334 (шаг 1): ссылка / своя запись — id и МОДЕЛЬ цели (у ссылки Odoo в ячейке имя, id — в значении)
                    const ref = store.getGridCellRef?.(event)
                    // webscm 2026 10 25 / ODOO-4334 (форма записи): пустое поле-ссылка формы — искать нечего: ни запроса, ни панели (прежде панель повторяла прошлый поиск)
                    if (ref && !ref.id) { event.preventDefault(); return }
                    const raw = store.getGridCellRawValue?.(event)
                    store.globalSearch.show(ref?.id || raw || searchValue, activeElement, { refs: true, target_segment: ref?.segment || '' })
                } else {
                    store.globalSearch.show(searchValue, activeElement)
                }
            } else if (event.key === "Escape" && event.altKey) {
                event.preventDefault()
                store.restoreLastClosedWidget()
            } else if (event.altKey && hotkey === "Alt N") {   // demo-webscm 2026 11 02 / ODOO-350612: навигатор интерфейса — правый док
                event.preventDefault()
                store.executeStoreMethod(store.activeWIDGET?.vueObj, { command: 'navigator_toggle' })
            } else if (event.altKey && hotkey === "Alt K") {
                event.preventDefault()
                store.executeStoreMethod(store.activeWIDGET?.vueObj, { tooltip: this.t('Open chats'), command: 'widget_open', widget: 'widget-chats' })   // IE 2026 09 23 / ODOO-341407: i18n
            } else if (event.altKey && hotkey === "Shift Alt V") { // Paste widget (JSON); Alt V остаётся за вставкой строк грида
                const grid = store.findFlexGridFromEvent(event);
                if (!grid) {
                    event.preventDefault()
                    if (store.activeWIDGET) {
                        store.executeStoreMethod(store.activeWIDGET.vueObj, { command: 'copyPaste', method: 'pasteWidget' })
                    } else {
                        store.pasteWidgetFromClipboard()
                    }
                }
            } else if (store.activeWIDGET) {

                // для совместимости
                if (!event.altKey && !event.ctrlKey && event.key === "F5") {
                    store.runActionForHotKey(store.activeWIDGET, "F5")
                } else if (event.altKey && event.key === "F5") { // Alt Enter
                    store.runActionForHotKey(store.activeWIDGET, "Alt Enter", null, { onceEvent: event })   // IE 2026 10 29 / ODOO-5800 (ie-dm7: Alt+Enter — один select)

                } else if (hotkey === "Alt Enter") { // Alt Enter
                    store.runActionForHotKey(store.activeWIDGET, "Alt Enter", null, { onceEvent: event })   // IE 2026 10 29 / ODOO-5800 (ie-dm7: Alt+Enter — один select): грид ниже по тому же событию — без второго select
                } else if (hotkey === "Shift Alt Enter") { // Shift Alt Enter
                    store.runActionForHotKey(store.activeWIDGET, "Shift Alt Enter", null, { onceEvent: event })   // IE 2026 10 29 / ODOO-5800 (ie-dm7: Alt+Enter — один select)

                } else if (event.altKey && hotkey === "Alt C") {
                    const grid = store.findFlexGridFromEvent(event);
                    if (!grid) {
                        event.preventDefault()
                        store.executeStoreMethod(store.activeWIDGET.vueObj, { command: 'copyPaste', method:'copyRecord' })
                    }
                } else if (event.altKey && hotkey === "Shift Alt C") {
                    const grid = store.findFlexGridFromEvent(event);
                    if (!grid) {
                        event.preventDefault()
                        store.executeStoreMethod(store.activeWIDGET.vueObj, { command: 'copyPaste', method:'copyWidget' })
                    }
                } else if (event.altKey && hotkey === "Alt S") {
                    event.preventDefault()
                    let targetWIDGET = store.activeWIDGET
                    if (targetWIDGET.widget === 'widget-row' && targetWIDGET.parentWIDGET?.id) {
                        targetWIDGET = store.findWidget(targetWIDGET.parentWIDGET.id)?.WIDGET || targetWIDGET
                    }
                    if (store.readonly_on()) store.readonly_toast()   // IE 2026 09 29 / ODOO-342781: роль «только чтение» — Alt+S ничего не сохраняет: тост «changes are not saved», запроса нет
                    else store.executeStoreMethod(targetWIDGET.vueObj, { command: 'onSaveRecord__Click', 'record_sendToBackend_exclude': ['_doc'] })

                } else if (event.key === "Escape") {
                    const _openSearch = [store.globalSearch, store.globalHistory, store.globalJob, store.globalLog].find(s => s?.visible)
                    if (store.i18nCard?.visible) {
                        // IE 2026 09 24 / ODOO-341407: сначала карточка «Translations» (и из её полей ввода — capture раньше поля)
                        store.i18nCard.hide()
                        event.preventDefault(); event.stopPropagation()
                    } else if (store.dropdown?.visible && !store.dropdown.cellForm_escAway?.()) {   // IE 2026 10 12 / ODOO-5800 (заказ Игоря: форма ячейки не закрывается при открытии из неё записей): Esc в другом виджете (открытой из формы записи) — тому виджету, форма ячейки остаётся
                        store.dropdown.hide()
                        event.preventDefault()
                    } else if (store.dropdown?.cfSuspended) {   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: открытая форма следует за выделением) — FB6b: форма спрятана, но открыта пользователем — Esc снимает признак (🏷 гаснет), виджет не закрывается
                        try { store.dropdown.vueObj?.cellForm_suspendClear?.(store.dropdown) } catch (e) { /* грид разрушен */ }
                        store.dropdown.cfSuspended = false; store.dropdown.sessionClose?.()
                        event.preventDefault()
                    } else if (store.openChipsDropdown) {
                        store.openChipsDropdown.showDropdown = false
                        event.preventDefault()
                    } else if (store.activeWIDGET?.attrs_vueObj?.WIDGET?.showDropdown) {
                        // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U3 (fix, без флага — найдено при подготовке объяснений widget.settings.panel):
                        // раньше Esc при открытой панели виджета (бейдж типа → «Settings | Variants») никак не обрабатывался здесь и уходил
                        // в store.runActionForHotKey(activeWIDGET, "Esc") ниже — первый Esc закрывал сам виджет вместо панели; теперь сначала
                        // закрывается панель (как и другие оверлеи этой ветки выше), Alt+Esc закрывает виджет как раньше (свой ветвью выше)
                        store.activeWIDGET.attrs_vueObj.WIDGET.showDropdown = false   // накат 26.09: компонент Widget.vue — attrs_vueObj.WIDGET (WIDGET.vueObj — общий компонент реквизитов, showDropdown у него нет)
                        event.preventDefault()
                    } else if (_openSearch) {
                        _openSearch.hide()
                        event.preventDefault()
                        event.stopPropagation()
                    } else {
                        const grid = store.findFlexGridFromEvent(event);
                        const tag = event.target?.tagName;
                        const isEditing = grid?.activeEditor || tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || event.target?.isContentEditable;
                        if (isEditing) {
                            // let native/component handle Esc (grid cancel-edit, input clear, etc.)
                        } else if (grid && escKeepGridFocus_decide({ flagOn: escKeepGridFocus_on((k, d) => store.setting?.(k, d)), inGrid: true, editorOpen: false, dirty: escKeepGridFocus_dirty(grid.hostElement?.__vueGrid) }) === 'keep') {
                            // IE 2026 10 14 / ODOO-5800 (app7 #83874, бот ev27b: Escape при закрытом редакторе уводил фокус на BODY — виджет закрывался
                            // скрытым действием Widget.vue {hotkey:'Esc'} → widget_close, и Ctrl+Z молчал до клика в сетку): при несохранённых правках
                            // грида Escape только схлопывает выделение и оставляет фокус на гриде; чистый грид — закрытие виджета как раньше. Флаг fe.ux.escKeepGridFocus
                            event.preventDefault(); event.stopPropagation()
                            escKeepGridFocus_apply(grid, document, document.getElementById('WIDGET' + store.activeWIDGET.id))   // IE 2026 10 24 / ODOO-348832: фокус — на контейнер виджета, следующий Escape закрывает виджет
                        } else {
                            const widgetContainer = document.getElementById('WIDGET' + store.activeWIDGET.id)
                            const focusInsideWidget = widgetContainer && event.target !== widgetContainer && widgetContainer.contains(event.target)
                            // IE 2026 09 17 / ODOO-… (замечание Игоря): фокус внутри виджета (холст карты / графа /
                            // канваса потоков после клика, кнопка панели) — снимаем его, но событие НЕ гасим: раньше
                            // первый Escape уходил только на blur, и виджет закрывался лишь вторым нажатием
                            if (focusInsideWidget && !grid) {
                                event.target.blur()
                            }
                            if (store.activeWIDGET?.styleWidget?._mobileMax) {
                                // IE 2026 09 15 / ODOO-… (замечание Игоря): виджет, развёрнутый на страницу (Alt F), первый Esc возвращает
                                // к обычному размеру; следующий Esc закрывает сам виджет
                                event.preventDefault()
                                store.executeStoreMethod(store.activeWIDGET.vueObj, { command: 'onWidgetMaxToggle__Click' })
                            } else {
                                store.runActionForHotKey(store.activeWIDGET, "Esc", event)
                            }
                        }
                    }
                } else if (event.altKey) {
                    // universal Alt hotkey handler — layout-independent
                    store.runActionForHotKey(store.activeWIDGET, hotkey, event)
                }
            }
        }
        document.addEventListener("keydown", this.handleKeydown, true) // capture phase — before grid handlers
        altTooltip.install(store) // IE 2026 09 07 / ODOO-337259: зажатый Alt — мгновенная подсказка элемента под мышью
        nativeTitles.install(store) // IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции): нативные title платформы → aria-label + короткое имя по Alt / Show tooltips (MutationObserver)
        this._onTipAction = (e) => { const a = e?.detail?.act; this._sbTipRelease?.(); if (a && a !== 'copy' && a !== 'copytext' && this.overlayMenuActive) { this.overlayMenuActive = false; this.mobileMenuActive = false } }   // IE 2026 09 23 / ODOO-… (заказ Игоря: кнопки в подсказках) · v2
        document.addEventListener('tip-action', this._onTipAction)
        tipActions.install(store) // IE 2026 09 23 / ODOO-… (заказ Игоря: кнопки в подсказках): клики по кнопкам внутри подсказки (document capture — раньше «клика мимо» панелей)
        recordHelp.install(store) // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2: установка recordHelp — поставщик объяснений записей ядра uiHelp (window._recordHelp)
        altTab.install(store) // IE 2026 09 08 / ODOO-… (заказ Игоря): Alt+Tab — переключатель виджетов (keyup Alt / blur окна)
        freeWidgets.install(store) // IE 2026 09 08 / ODOO-… (заказ Игоря): режимы поведения свободных виджетов (watch activeWIDGET)
    },
    beforeUnmount() {
        this._topbarResizeObserver?.disconnect()
        window.removeEventListener('resize', this.scroll)
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout)
        }
        window.removeEventListener('scroll', this.scroll)
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout)
        }
      
        document.removeEventListener("keydown", this.handleKeydown, true)
        altTooltip.uninstall() // IE 2026 09 07 / ODOO-337259
        nativeTitles.uninstall() // IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции)
        document.removeEventListener('tip-action', this._onTipAction)   // IE 2026 09 23 / ODOO-… (заказ Игоря: кнопки в подсказках) · v2
        tipActions.uninstall() // IE 2026 09 23 / ODOO-… (заказ Игоря: кнопки в подсказках)
    },
    computed: {
        helpCardOn() { return helpCard_on(this.store) },   // IE 2026 11 03 / ODOO-350881: карточка помощи окна монтируется только при флаге
        // IE 2026 10 29 / ODOO-5800 (заказ Игоря 29.10: иконка панели столов — «panel-left» с состоянием открыто/закрыто; «Страницы» в шапке — глиф вкладок): панель списка столов открыта — desktop: overlay → overlayMenuActive, static → !staticMenuInactive; mobile → mobileMenuActive
        // (ширина окна не реактивна: пересчёт — при смене любого из флагов; те же флаги рисуют containerClass)
        sidebarOpen() {
            if (this.isDesktop()) {
                if (this.layoutMode === 'static') return !this.staticMenuInactive
                return !!this.overlayMenuActive
            }
            return !!this.mobileMenuActive
        },
        containerClass() {
            return ['layout-wrapper', {
                'layout-overlay': this.layoutMode === 'overlay',
                'layout-static': this.layoutMode === 'static',
                'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
                'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
                'layout-mobile-sidebar-active': this.mobileMenuActive,
				'p-input-filled': this.$primevue.config.inputStyle === 'filled',
				'p-ripple-disabled': this.$primevue.config.ripple === false,
				'dark-theme': this.$appState.darkTheme,
                // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p219 опції й види — у стилі чипів глобального пошуку, кольором теми замість жовтого): выключатель fe.ux.optionChipsThemeColor (дефолт ВКЛ; ВЫКЛ — прежние цвета)
                'opt-chips-theme': this.store?.setting('fe.ux.optionChipsThemeColor', true) !== false,
                'opt-chips-soft': this.store?.setting('fe.ux.optionChipsSoftPressed', true) !== false,   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p229 натиснуті кнопки опцій — м'яка підкладка замість інверсії): выключатель fe.ux.optionChipsSoftPressed (дефолт ВКЛ; ВЫКЛ — заливка цветом темы, p219)
                'hdr-opt-align': this.store?.setting('fe.ux.headerOptionButtonsAlign', true) !== false,   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: кнопка Σ і глаз — як інші кнопки опцій): выключатель fe.ux.headerOptionButtonsAlign (дефолт ВКЛ; ВЫКЛ — Σ без рамки и зазора, как в p217)
                'active-btn-tint': this.store?.setting('fe.ux.activeButtonTint', true) !== false,   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: лёгкий тон активных кнопок без рамки): выключатель fe.ux.activeButtonTint (дефолт ВКЛ; ВЫКЛ — серая подложка p229)
                'ui-font-unify': this.store?.setting('fe.ux.uiFontUnify', true) !== false,   // IE 2026 11 02 / ODOO-350449 (ревью webscm #125869): p215 единый шрифт — под выключателем
                'grid-hdrchk-align': this.store?.setting('fe.ux.gridHeaderCheckAlign', true) !== false,   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: чекбокс заголовка колонки выбора строк — в линию с чекбоксами строк): выключатель fe.ux.gridHeaderCheckAlign (дефолт ВКЛ; ВЫКЛ — как до p240)
            }]
        },
        mainContainer() {
            return ['main-container', {
                // IE 2026 09 26 / ODOO-… (замечание Игоря: баннер предупреждения стола): доп. отступ контейнера — пока в шапке виден ряд
                // предупреждения (баннер или прежняя полоса); скрытый ✕ баннер места не держит
                'main-container-with-notification': !!this.wsAlert || (!!this.PAGE?.notification?.visible && !this.wsAlertBannerOn),
            }]
        },
        // demo-webscm 2026 11 02 / ODOO-350612: док навигатора справа сжимает страницу (margin-right = ширина дока; MainArea.calculatePage_px читает offsetWidth контейнера — он
        // уменьшается вместе с margin); свободное окно страницу не трогает; на мобильном UI док — нижний лист, без отступа.
        // (замечание владельца: «при сворачивании… экран не сразу перерисовывается… элементы виджетов ложатся под него. И при открытии тоже»): смужка тоже занимает место
        // (navigator_reserve), а пересчёт раскладки идёт в watch navReserve — в том же такте, что и смена margin (раньше: событие resize до обновления DOM + два дебаунса по 200 мс)
        navReserve() { return navigator_reserve(this.store.navigator, this.store.mobileUi?.on) },
        mainContainerStyle() {
            const w = this.navReserve
            return w ? { marginRight: w + 'px' } : null
        },
        logo() {
            return (this.$appState.darkTheme) ? "images/logo-white.svg" : "images/logo.svg";
        },
        viewKey() {
            // <router-view v-slot="{ Component }" :key="viewKey" >
            return `${this.$route.params.workspace || ''}-${this.$route.params.page || ''}`
        },
        routeViewKey() {
            // ключ route-компонента: как fullPath, но БЕЗ process_model —
            // смена модели (pmKeepView) меняет только данные, не дерево DOM
            const q = { ...this.$route.query }
            delete q.process_model
            const qs = Object.keys(q).sort().map(k => `${k}=${q[k]}`).join('&')
            // IE 2026 09 26 / ODOO-… (замечание Игоря: «+» на новой странице): + номер пересборки стола (store.wsReopen_mark) — страницы, открытые
            // до «Save as new page», создаются заново вместо экземпляров из кэша со старым объектом стола
            return this.$route.path + (qs ? '?' + qs : '') + this.routeReopenSuffix(q.workspace, q.page)
        },
		PAGE() {
			return this.store.activeWORKSPACE?.activePAGE
		},
		// IE 2026 09 26 / ODOO-… (замечание Игоря: баннер предупреждения стола): предупреждение страницы — компактным жёлтым баннером
		// (настройка базы fe.ux.wsAlertBanner, по умолчанию вкл; false — прежняя полоса во всю ширину); мобильный профиль — прежняя полоса (в нём своя раскладка
		// шапки: --mob-topbar-h меряет .topbar целиком)
		wsAlertBannerOn() {
			return this.store?.setting?.('fe.ux.wsAlertBanner', true) !== false && !this.store?.mobileUi?.on
		},
		// показываемое предупреждение или null: текст — как у прежней полосы (header + text); скрытое ✕ не показывается до перезагрузки вкладки
		wsAlert() {
			if (!this.wsAlertBannerOn) return null
			const n = this.PAGE?.notification
			if (!n || !n.visible) return null
			const str = (v) => (v === undefined || v === null ? '' : (typeof v === 'string' ? v : (typeof v === 'object' ? JSON.stringify(v) : String(v)))).trim()
			const text = [str(n.header), str(n.text)].filter(Boolean).join(' ')
			if (!text) return null
			const status = ['warning', 'pending', 'info', 'error', 'critical'].includes(n.status) ? n.status : 'warning'
			const key = this.wsAlert_key(text, status)
			if (this.wsAlertClosed[key]) return null
			return { text, status, key }
		},
		// подпись показанного баннера: появился / скрыт / сменился — шапка другой высоты (вотчер пересчитывает полосу под шапкой)
		wsAlertSig() {
			return this.wsAlert ? this.wsAlert.key : ''
		},
		// IE 2026 09 27 / ODOO-… (заказ Игоря: Open task в баннере предупреждения стола): кнопка «Open task» — открыть задачу, из-за которой висит
		// предупреждение (check-task строки страницы в doc.pages стола; utils/wsAlertTask.js). Выключатель fe.ux.wsAlertOpenTask (по умолчанию вкл.).
		// Кому — как панель задач: fe.ux.tasksPanelAllUsers (решение Игоря 27.09 — всем; false — только администраторам)
		wsAlertOpenTaskOn() {
			const st = this.store
			if (!st || st.setting?.('fe.ux.wsAlertOpenTask', true) === false) return false
			if (st.setting?.('fe.ux.tasksPanelAllUsers', true) !== false) return true
			try { return !!st.checkAccess?.({ viewAccess: 'access-admin' }) } catch (e) { return false }
		},
		// id задач предупреждения текущей страницы (PAGES[страница]['check-task'] + строки doc.pages стола этой страницы) — только пока баннер показан
		wsAlertTaskIds() {
			if (!this.wsAlert || !this.wsAlertOpenTaskOn) return []
			const W = this.store?.activeWORKSPACE
			return wsAlertTasks_of(this.PAGE, this.PAGE?.page || W?.active_page, W?.record?.doc?.pages)
		},
		// задачи кнопки: названия и сегменты — ответ catalog_titles (кэш «язык|id»); до ответа — id; записи нет — задача не показывается
		wsAlertTasks() {
			const lang = getLanguage(), info = {}
			for (const id of this.wsAlertTaskIds) { const x = this.wsAlertTaskInfo[lang + '|' + id]; if (x) info[id] = x }
			return wsAlertTasks_items(this.wsAlertTaskIds, info)
		},
		wsAlertTasksNames() { return wsAlertTasks_names(this.wsAlertTasks) },
		// набор задач баннера (язык + id): сменился — названия и сегменты запрашиваются заранее (вотчер)
		wsAlertTasksSig() { return this.wsAlertTaskIds.length ? getLanguage() + '|' + this.wsAlertTaskIds.join(',') : '' },
    },
    methods: {
        // IE 2026 09 26 / ODOO-… (замечание Игоря: «+» на новой странице): суффикс ключа страницы — номер пересборки стола; входит в ключ, только когда
        // у ТЕКУЩЕГО объекта стола уже есть страница маршрута (пока объекта нет / маршрут ещё на прежней странице — прежний суффикс: иначе смонтировалась бы
        // страница без стола); память — вне реактивности (_routeReopenMemo)
        routeReopenSuffix(ws, page) {
            const serial = (ws && this.store?.wsReopenSerial?.[ws]) || 0
            if (!serial) return ''
            const W = this.store.WORKSPACES?.[ws]
            if (W && page && W.PAGES?.[page]) _routeReopenMemo[ws] = serial
            return _routeReopenMemo[ws] ? '#r' + _routeReopenMemo[ws] : ''
        },
        reloadForUpdate() {
            // жёсткая перезагрузка: index.html и бандл берутся с сервера, а не из кэша
            const u = new URL(window.location.href)
            u.searchParams.set('_v', String(Date.now()))
            window.location.replace(u.toString())
        },
        // IE 2026 09 26 / ODOO-… (замечание Игоря: баннер предупреждения стола): ключ скрытия — «стол | статус | текст»: скрытое
        // на одной странице стола не возвращается и на других его страницах с тем же предупреждением; другое предупреждение (текст / статус) покажется снова
        wsAlert_key(text, status) {
            const W = this.store?.activeWORKSPACE
            return `${W?.workspace || W?.record?.id || ''}|${status || ''}|${text || ''}`
        },
        // ✕ баннера: скрыть до перезагрузки вкладки (состояние компонента — ни в хранилище браузера, ни на сервер ничего не пишется)
        wsAlert_close() {
            const a = this.wsAlert
            if (!a) return
            this.wsAlertClosed = { ...this.wsAlertClosed, [a.key]: Date.now() }
        },
        // IE 2026 09 27 / ODOO-… (заказ Игоря: Open task в баннере предупреждения стола): названия и сегменты задач баннера — ОДИН запрос
        // catalog_titles на новые id (как у панели задач и тиража); id без записи — { miss: true } (кнопки нет); сбой / нет ответа 8 с — id остаётся
        // без названия (кнопка откроет запись по id), спросится при следующем показе
        wsAlert_resolveTasks() {
            const lang = getLanguage()
            const need = this.wsAlertTaskIds.filter((id) => !this.wsAlertTaskInfo[lang + '|' + id])
            if (!need.length || typeof this.store?.executeBackendMethod !== 'function') return Promise.resolve(0)
            const key = lang + '|' + need.join(',')
            const asks = this._wsAlertTaskAsks || (this._wsAlertTaskAsks = {})
            if (asks[key]) return asks[key]
            asks[key] = new Promise((resolve) => {
                let done = false
                const fin = (titles) => {
                    if (done) return
                    done = true
                    delete asks[key]
                    const got = wsAlertTasks_fromTitles(need, titles)
                    if (got) {
                        const add = {}
                        for (const id in got) add[lang + '|' + id] = got[id]
                        this.wsAlertTaskInfo = { ...this.wsAlertTaskInfo, ...add }
                    }
                    resolve(got ? need.length : 0)
                }
                try { this.store.executeBackendMethod({}, { method: 'catalog_titles', params: { ids: need } }, (answer) => fin(answer && answer.titles)) } catch (e) { fin(null) }
                setTimeout(() => fin(null), 8000)
            })
            return asks[key]
        },
        // «Open task»: запись задачи — на ТЕКУЩЕЙ странице стола, с активацией: то же действие, что у пункта панели задач (tasksPanel_openAction →
        // widget_open widget-record без родителя-виджета); уже открытая на странице запись этой задачи выходит вперёд (findWidget_byProps). Ответ
        // catalog_titles ещё в пути — ждём до 1,5 с (название в шапке виджета сразу; id без записи не открывается)
        async wsAlert_openTask() {
            if (!this.wsAlertTasks.length) return
            await Promise.race([this.wsAlert_resolveTasks(), new Promise((r) => setTimeout(r, 1500))])
            for (const task of this.wsAlertTasks) {
                const action = tasksPanel_openAction({ id: task.id, segment: task.segment, title: task.title })
                if (!action) continue
                try { this.store.executeStoreMethod(this, action) } catch (e) { console.warn('ws alert: open task failed', task.id, e) }
            }
        },
        // полоса под шапкой — стопка: ряд предупреждения (внутри .topbar — его высота уже в низу шапки) и под ним плашка новой версии (fixed; её высота —
        // store.updateBannerOffset); поле виджетов (MainArea: низ .topbar + updateBannerOffset) — ниже обоих. Зовётся при показе / скрытии любого из них
        topBanners_layout() {
            const relayout = () => this.store?.activeWORKSPACE?.activePAGE?.mainArea?.vueObj?.setStyle?.(0)
            this.$nextTick(() => {
                const tb = this.$refs.topbar
                const r = tb ? tb.getBoundingClientRect() : null
                const row = !!(tb && tb.querySelector('.ws-alert-row'))
                // IE 2026 11 01 / ODOO-350597 (дефект Андрея, #123143): шапка стала другой высоты (ряд предупреждения появился / скрыт / другая страница) —
                // рейл страницы без раскладки пересчитывает отступ от этого значения (Page.pageButtonsStart)
                this.store.topbarBottom = topbarBottom_px(tb)
                // плашка версии — под шапкой через 4 px; под рядом предупреждения — вплотную (у ряда свой нижний отступ 4 px)
                this.updateBannerTop = (r ? Math.round(r.bottom) + (row ? 0 : 4) : 50) + 'px'
                this.$nextTick(() => {
                    let off = 0
                    if (this.store?.version_outdated) {
                        const el = document.querySelector('.update-banner')
                        const h = el ? Math.round(el.getBoundingClientRect().height) : 34
                        off = h + (row ? 4 : 8)
                    }
                    const sig = `${row ? 1 : 0}|${off}|${r ? Math.round(r.height) : 0}`
                    const changed = off !== this.store.updateBannerOffset || sig !== this._topBannersSig
                    this.store.updateBannerOffset = off
                    this._topBannersSig = sig
                    if (changed) relayout()
                })
            })
        },
        stopTestRecording() {
            this.store.executeStoreMethod({ WIDGET: {} }, { command: 'test_record_stop' })
        },
        handleMouseLeave(e) {
            // IE 2026 09 04 / ODOO-336291 (mobile UX): B-26 / P-19 hamburgerTap — совместимый mouseleave на таче не закрывает сайдбар
            if (this.store?.mobileUi?.on && this.store.mobileUi.hamburgerTap !== false) return
            // IE 2026 09 23 / ODOO-… (заказ Игоря: кнопки в подсказках) · v2: курсор ушёл с сайдбара на ПОДСКАЗКУ его строки (кнопки-действия) — сайдбар держится; закроется, когда курсор уйдёт и с подсказки
            // (не назад в сайдбар), либо после действия из подсказки (tip-action, кроме копирования)
            const _tip = e?.relatedTarget?.closest?.('.wj-tooltip')
            if (_tip) {
                // IE 2026 09 23 / ODOO-… (заказ Игоря: кнопки в подсказках) · v4: одноразово и только для этой подсказки (по её содержимому — элемент общий), снимается и по tip-action
                this._sbTipRelease?.()
                const sig = String(_tip.innerHTML || '').slice(0, 400)
                const onLeave = (ev) => { this._sbTipRelease?.(); if (String(_tip.innerHTML || '').slice(0, 400) !== sig) return; const to = ev?.relatedTarget; if (to?.closest?.('.layout-sidebar')) return; this.overlayMenuActive = false; this.mobileMenuActive = false }
                this._sbTipRelease = () => { this._sbTipRelease = null; _tip.removeEventListener('mouseleave', onLeave) }
                _tip.addEventListener('mouseleave', onLeave)
                return
            }
            // console.log('mouseleave')
            // if (!this.menuClick) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            // }

            this.menuClick = false;
        },
        onWrapperClick() {
            if (!this.menuClick) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }

            this.menuClick = false;
        },
        onMenuToggle() {
            // IE 2026 08 20 / ODOO-336291 (mobile UX): открытие бокового меню закрывает мобильный рейл страниц
            if (this.store?.mobileUi?.railOpen) this.store.mobileUi.railOpen = false
            this.menuClick = true;

            if (this.isDesktop()) {
                if (this.layoutMode === 'overlay') {
					if(this.mobileMenuActive === true) {
						this.overlayMenuActive = true;
					}

                    this.overlayMenuActive = !this.overlayMenuActive;
					this.mobileMenuActive = false;
                }
                else if (this.layoutMode === 'static') {
                    this.staticMenuInactive = !this.staticMenuInactive;
                }
            }
            else {
                this.mobileMenuActive = !this.mobileMenuActive;
                if (this.mobileMenuActive) {
                    this.store?.mobileMenus_closeOthers?.('sidebar') // IE 2026 09 04 / ODOO-336291 (mobile UX): B-08 menuExclusive — рейл / список виджетов / «⋮» закрываются
                    window.mobTapDone?.('hamburger') // IE 2026 09 04 / ODOO-336291 (mobile UX): P-31
                }
            }

            event.preventDefault();
        },
        onSidebarClick() {
            this.menuClick = true;
        },
        onMenuItemClick(event) {
            if (event.item && !event.item.items) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }
        },
        // IE 2026 10 29 / ODOO-5800 (заказ Игоря 29.10: кнопка «закрыть список столов» на месте кнопки шапки — панель в overlay накрывает шапку): закрыть список столов
        // кнопкой в его заголовке — desktop static → staticMenuInactive = true, иначе (overlay, mobile) → overlayMenuActive = false; mobileMenuActive = false всегда.
        // menuClick не трогаем: клик всплывает в .layout-sidebar (onSidebarClick ставит menuClick), onWrapperClick его только сбрасывает
        onSidebarClose() {
            if (this.isDesktop() && this.layoutMode === 'static') this.staticMenuInactive = true
            else this.overlayMenuActive = false
            this.mobileMenuActive = false
            // IE 2026 10 29 / ODOO-5800 (заказ Игоря 29.10: кнопка «закрыть список столов» на месте кнопки шапки — без повторного открытия наведением): в overlay кнопка закрытия стоит над кнопкой шапки — курсор после закрытия на ней; до ухода мыши с неё наведение не открывает список
            // (static: панель под шапкой, курсор не на кнопке — запрет не ставится)
            if (!(this.isDesktop() && this.layoutMode === 'static')) this.sidebarHoverLock = true
        },
		onLayoutChange(layoutMode) {
			this.layoutMode = layoutMode;
		},
        addClass(element, className) {
            if (element.classList)
                element.classList.add(className);
            else
                element.className += ' ' + className;
        },
        removeClass(element, className) {
            if (element.classList)
                element.classList.remove(className);
            else
                element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        isDesktop() {
            return window.innerWidth >= 992;
        },
        isSidebarVisible() {
            if (this.isDesktop()) {
                if (this.layoutMode === 'static')
                    return !this.staticMenuInactive;
                else if (this.layoutMode === 'overlay')
                    return this.overlayMenuActive;
            }

            return true;
        },
        // demo-webscm 2026 11 02 / ODOO-350612: свободная область страницы стала шире / уже на d px (док навигатора) — ректы свободных виджетов по X
        // масштабируются от её левого края (navigator_areaRescaleX); область — по stylePage активной страницы ДО пересчёта (getPAGE_size)
        popouts_rescaleArea(d) {
            const store = this.store
            const PAGE = store?.activeWORKSPACE?.activePAGE
            if (!PAGE?.stylePage || typeof store.getPAGE_size !== 'function') return
            const ps = store.getPAGE_size(PAGE)
            if (!(ps.page_width > 0)) return
            const oldArea = { left: ps.page_left, width: ps.page_width }, nextArea = { left: ps.page_left, width: ps.page_width + d }
            for (const ws of Object.values(store.WORKSPACES || {})) {
                for (const WIDGET of (ws.ALL_WIDGETS ?? [])) {
                    if (WIDGET?.styleWidget?.dock !== 'popout') continue
                    const el = document.getElementById(`WIDGET${WIDGET.id}`)
                    if (!el) continue
                    const r = navigator_areaRescaleX({ left: Number.parseInt(el.style.left, 10), width: Number.parseInt(el.style.width, 10) }, oldArea, nextArea)
                    if (!r) continue
                    el.style.left = r.left + 'px'
                    el.style.width = r.width + 'px'
                }
            }
        },
        resize() {
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }
            // IE 2026 09 04 / ODOO-336291 (mobile UX): B-35 rotateSync — поворот экрана (сменилась ШИРИНА)
            // раскладывается в том же проходе, без 200 мс дебаунса; трейлинг-проход остаётся.
            // Изменение только высоты (клавиатура iOS, адресная строка) идёт прежним путём.
            // Выкл: window.mobileUi.set('rotateSync', false)
            if (this.store?.mobileUi?.on && this.store.mobileUi.rotateSync !== false) {
                const w = window.innerWidth
                if (this._mobRotW && this._mobRotW !== w) this.resize_afterTimer()
                this._mobRotW = w
            }
            this.resizeTimeout = setTimeout(this.resize_afterTimer, this.store?.setting('fe.ux.resizeDebounceMs', 200) ?? 200);   // IE 2026 09 05 / ODOO-336330
        },
        resize_afterTimer() {
            const newW = window.innerWidth - this.navReserve   // demo-webscm 2026 11 02 / ODOO-350612: свободные виджеты масштабируются по свободной области, не по экрану
            const newH = window.innerHeight
            if (this._prevW && this._prevH && (newW !== this._prevW || newH !== this._prevH)) {
                this.store.rescale_popouts(newW / this._prevW, newH / this._prevH)
            }
            this._prevW = newW
            this._prevH = newH
            this.store.topbarBottom = topbarBottom_px(this.$refs.topbar)   // IE 2026 11 01 / ODOO-350597: шапка могла перенести строки — рейл страницы без раскладки

            if (this.scrollTimeout) {
                clearTimeout(this.scrollTimeout)
            }
            this.scroll_afterTimer()
        },
        scroll() {
            if (this.scrollTimeout) {
                clearTimeout(this.scrollTimeout)
            }
            this.scrollTimeout = setTimeout(this.scroll_afterTimer, this.store?.setting('fe.ux.resizeDebounceMs', 200) ?? 200)   // IE 2026 09 05 / ODOO-336330
        },
        scroll_afterTimer() {
            this.store?.activeWORKSPACE?.activePAGE?.mainArea?.vueObj.checkWorkspaceScroll()
        },
    },
    beforeUpdate() {
        if (this.mobileMenuActive)
            this.addClass(document.body, 'body-overflow-hidden');
        else
            this.removeClass(document.body, 'body-overflow-hidden');
    },
    watch: {
        // demo-webscm 2026 11 02 / ODOO-350612 (замечание владельца: док / смужка — «экран не сразу перерисовывается… элементы виджетов ложатся под него»): место справа
        // изменилось (открыли / закрыли / свернули в смужку / потянули кромку) → после применения margin в DOM (nextTick) раскладка страницы и границы свободных окон
        // пересчитываются СРАЗУ, минуя дебаунсы App.resize (200 мс) и MainArea.setStyle (200 мс): setStyle_afterTimeout → calculatePage_px + checkPopout
        // ODOO-350612 (слово владельца: «когда я сжимаю панель навигатора не возвращается назад пространство под виджеты… их позиция считается относительно
        // ширины экрана. А нужно относительно свободной области»): docked-виджеты уже следовали за margin (calculatePage_px → offsetWidth), а свободные только
        // обрезались по правому краю (checkPopout) и обратно не росли — полоса пустоты. Теперь до пересчёта их ректы масштабируются по ширине свободной
        // области (старая → новая), относительно её левого края; checkPopout после этого ничего не обрезает
        navReserve(n, o) {
            const d = (Number(o) || 0) - (Number(n) || 0)
            if (d) this.popouts_rescaleArea(d)
            this._prevW = window.innerWidth - (Number(n) || 0)   // следующий resize окна считает от новой свободной области, без двойного масштабирования
            this.$nextTick(() => {
                const ma = this.store?.activeWORKSPACE?.activePAGE?.mainArea?.vueObj
                try { if (ma && typeof ma.setStyle_afterTimeout === 'function') ma.setStyle_afterTimeout(); else this.resize_afterTimer() } catch (e) { this.resize() }
            })
        },
        // IE 2026 09 04 / ODOO-336291 (mobile UX): B-08 menuExclusive — сайдбар зеркалится в store.mobileUi.sidebarOpen; сброс снаружи закрывает его
        mobileMenuActive(v) { if (this.store?.mobileUi) this.store.mobileUi.sidebarOpen = !!v },
        'store.mobileUi.sidebarOpen'(v) { if (!v && this.mobileMenuActive) this.mobileMenuActive = false },
        $route() {
            this.menuActive = false;
            this.$toast.removeAllGroups();
        },
        // IE 2026 08 27 (Igor): плашка устаревшей версии — между строкой чипсов (шапкой) и полем виджетов
        'store.version_outdated'() {
            // IE 2026 08 27 / ODOO-5800 (заказ Игоря): плашка — в полосе между шапкой и полем виджетов:
            // сама плашка сразу под шапкой, а раскладка страницы (stylePage.marginTop в MainArea)
            // сдвигается вниз на её высоту через store.updateBannerOffset
            // IE 2026 09 26 / ODOO-… (замечание Игоря: баннер предупреждения стола): расчёт — общий со стопкой баннеров (под рядом
            // предупреждения страницы, если он показан): topBanners_layout
            this.topBanners_layout()
        },
        // баннер предупреждения появился / скрыт ✕ / другая страница — шапка другой высоты: место плашки версии и раскладка поля виджетов заново
        wsAlertSig(v) {
            // IE 2026 11 01 / ODOO-350597 (дефект Андрея, #123143): подпись ряда — в стор до перерисовки шапки (pre-flush): рейл страницы без раскладки
            // (Page.pageButtonsStart) помечается грязным в том же проходе и читает уже перерисованную шапку — без кадра со старой высотой
            this.store.wsAlertSig = v || ''
            this.topBanners_layout()
        },
        // IE 2026 09 27 / ODOO-… (заказ Игоря: Open task в баннере предупреждения стола): задачи баннера сменились (страница / стол / язык) —
        // названия и сегменты заранее, одним запросом на новые id
        wsAlertTasksSig: {
            immediate: true,
            handler() { if (this.wsAlertTaskIds.length) this.wsAlert_resolveTasks() },
        },
    },
    components: {
        'AppTopBar': AppTopBar,
        // 'ControlPanel': ControlPanel,
        'AppMenu': AppMenu,
        'RailMenu': RailMenu,
        'AltTabSwitcher': AltTabSwitcher, // IE 2026 09 08 / ODOO-… (Alt+Tab)
        'I18nTitles': I18nTitles, // IE 2026 09 24 / ODOO-341407 (карточка «Translations»)
        'I18nSwitchProgress': I18nSwitchProgress, // IE 2026 09 25 / ODOO-341407 (индикатор хода переключения языка)
        'MfaSecurityDialog': MfaSecurityDialog, // Odoo 350042
        'HelpCard': HelpCard, // IE 2026 11 03 / ODOO-350881
        'RecordHelpDialog': RecordHelpDialog, // IE 2026 09 25 / ODOO-… (замечание Игоря: многострочный диалог описания записи)
        'FreeWidgetsStrip': FreeWidgetsStrip, // IE 2026 09 08 / ODOO-… (free widgets behavior)
        'NavigatorDock': NavigatorDock, // demo-webscm 2026 11 02 / ODOO-350612
        'GuideBar': GuideBar, // IE 2026 09 28 / ODOO-342342 (Use cases)
        'ApprovalHistory': ApprovalHistory, // IE 2026 10 09 / ODOO-345618 (F2)
        // 'AppFooter': AppFooter,
    }
}
</script>

<style lang="scss">
@import './App.scss';
@import './scm_core.scss';
@import '../node_modules/@mescius/wijmo.styles/themes/material/wijmo.theme.material.indigo-amber.css';

// ODOO-3705: оверлей переключения базы
.db-switching {
    position: fixed;
    inset: 0;
    z-index: 20000;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.75);
    backdrop-filter: blur(2px);
}
.db-switching-box {
    text-align: center;
    padding: 28px 36px;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 6px 28px rgba(0, 0, 0, 0.18);
    min-width: 280px;
}
.db-switching-icon {
    font-size: 30px;
    color: #2196f3;
}
.db-switching-title {
    margin-top: 14px;
    font-size: 15px;
    color: #6c757d;
}
.db-switching-db {
    margin-top: 4px;
    font-size: 19px;
    font-weight: 600;
}
.db-switching-note {
    margin-top: 12px;
    font-size: 13px;
    color: #6c757d;
}

.wj-control * {
    font-size: 0.875rem;
}
.wj-control a {
    font-size: 0.875rem;
}

/* ==== Цветовые гаммы: единая палитра на CSS-переменных =======================
   5 схем из COLOR_SCHEMES (mainStore.js). Класс на body: cscheme-<id>.
   ЕДИНЫЙ ИСТОЧНИК ПРАВДЫ — переменные --cs-* ниже: каждая схема задаёт только
   свой набор значений, а правила (здесь И в AttrGrid.vue) ссылаются на var(--cs-*).
   Меняем цвет схемы → правим одну переменную, меняется везде согласованно.
   'classic' переопределений не имеет (дефолтный вид) и переменные не задаёт.
   Стиль глобальный (не scoped): классы висят на body, переменные видны всему DOM.

   Назначение переменных:
     --cs-topbar-bg/-fg/-accent  топбар: фон / текст-иконки / hover-акцент
     --cs-topbar-border          линия снизу топбара (акцент бренда)
     --cs-page-bg                фон контентной области
     --cs-icon                   иконки левого блока (согласуем с брендом)
     --cs-title                  заголовки рабочей области и виджетов (IE 2026 11 02 / ODOO-349799 (workspace-wording))
     --cs-badge-bg/-fg           бейджи-счётчики
     --cs-header-bg/-fg          шапки таблиц: фон / текст
     --cs-header-border          разделители внутри шапки
     --cs-header-accent          линия-акцент под шапкой
     --cs-grid-border            рамка грида
     --cs-cell-border            границы ячеек данных
     --cs-group1-bg              групп-строка ур.1 (светлее)
     --cs-group2-bg/-fg          групп-строка ур.2 (темнее) / её текст
     --cs-zebra-bg               чётные строки (зебра)
     --cs-chip-border            обводка контейнера чипсов
     --cs-scroll-thumb/-hover    ползунок скролла / его hover */

/* ---- style1c (1С:Предприятие): тёплый золотой ------------------------------ */
body.cscheme-style1c {
    --cs-topbar-bg: #f2c14e;   --cs-topbar-fg: #3a3320;   --cs-topbar-accent: #8a6d1f;
    --cs-topbar-border: transparent;
    --cs-page-bg: #faf8f0;
    --cs-icon: #b07d1a;        --cs-title: #7a5e12;
    --cs-badge-bg: #e6b84a;    --cs-badge-fg: #3a3320;
    --cs-header-bg: #f4efe0;   --cs-header-fg: #3a3320;
    --cs-header-border: #e0d6b8; --cs-header-accent: #d8b84e;
    --cs-grid-border: #e6ddc4; --cs-cell-border: rgba(90,70,20,0.06);
    --cs-group1-bg: #faf6ea;   --cs-group2-bg: #f0e6c8;  --cs-group2-fg: #3a3320;
    --cs-zebra-bg: #fdfbf4;
    --cs-chip-border: #e0d6b8;
    --cs-info-bg: #efe8d6;
    --cs-accent: #c99a2e;
    --cs-act-tint-pct: 12%; --cs-act-tint-hover-pct: 21%;   /* IE 2026 11 03 / ODOO-350449 (webscm #128539: контраст «Лёгкого тона» — текст ≥ 4,6, заливка отличима, без рамки): золотой акцент светлый — 9 % дают 1,08 / 1,06 (светлая / тёмная) к подложке, ниже Classic 9 % (1,10 / 1,07); 12 % — 1,11 / 1,08 */
    --cs-scroll-thumb: rgba(138,109,31,0.30); --cs-scroll-hover: rgba(138,109,31,0.55);
}

/* ---- style2o (Odoo): фиолетовый топбар, белые шапки ------------------------- */
body.cscheme-style2o {
    --cs-topbar-bg: #714B67;   --cs-topbar-fg: #ffffff;   --cs-topbar-accent: #a884a0;
    --cs-topbar-border: transparent;
    --cs-page-bg: #f9f7fa;
    --cs-icon: #714B67;        --cs-title: #5a3b52;
    --cs-badge-bg: #714B67;    --cs-badge-fg: #ffffff;
    --cs-header-bg: #ffffff;   --cs-header-fg: var(--cs-muted); /* приглушённая шапка таблиц */
    --cs-header-border: #e6ebee; --cs-header-accent: #cfd8dc;
    --cs-grid-border: #e3e9ec; --cs-cell-border: rgba(0,0,0,0.05);
    --cs-group1-bg: #f7f9fa;   --cs-group2-bg: #eef2f4;  --cs-group2-fg: #2f3b42;
    --cs-zebra-bg: #fafbfc;
    --cs-chip-border: #e6ebee;
    --cs-info-bg: #eef1f3;
    --cs-accent: #714B67;
    --cs-scroll-thumb: rgba(113,75,103,0.30); --cs-scroll-hover: rgba(113,75,103,0.55);
}

/* ---- style3k (Kinaxis): тёмно-синий + бирюза -------------------------------- */
body.cscheme-style3k {
    --cs-topbar-bg: #0a2536;   --cs-topbar-fg: #ffffff;   --cs-topbar-accent: #00a9ce;
    --cs-topbar-border: #00a9ce;
    --cs-page-bg: #eef3f6;
    --cs-icon: #00a9ce;        --cs-title: #0a2536;
    --cs-badge-bg: #00a9ce;    --cs-badge-fg: #ffffff;
    /* заголовки: смягчено с резкого тёмно-синего #123047 (по просьбе — near #40737f) */
    --cs-header-bg: #40737f;   --cs-header-fg: #eef4f6;
    --cs-header-border: #35616c; --cs-header-accent: #00a9ce;
    --cs-grid-border: #d3dee5; --cs-cell-border: rgba(10,37,54,0.06);
    --cs-group1-bg: #e6eef3;   --cs-group2-bg: #d3e0e8;  --cs-group2-fg: #0a2536;
    --cs-zebra-bg: #f4f8fa;
    --cs-chip-border: #cdd9e0;
    --cs-info-bg: #dfe8ee;
    --cs-accent: #00a9ce;
    --cs-scroll-thumb: rgba(0,169,206,0.35); --cs-scroll-hover: rgba(0,169,206,0.60);
}

/* ---- style4s (SAP Fiori): сине-серый shell, синий акцент -------------------- */
body.cscheme-style4s {
    --cs-topbar-bg: #354a5f;   --cs-topbar-fg: #ffffff;   --cs-topbar-accent: #0a6ed1;
    --cs-topbar-border: transparent;
    --cs-page-bg: #f7f7f7;
    --cs-icon: #0a6ed1;        --cs-title: #32363a;
    --cs-badge-bg: #0a6ed1;    --cs-badge-fg: #ffffff;
    --cs-header-bg: #f2f2f2;   --cs-header-fg: #32363a;
    --cs-header-border: #d9d9d9; --cs-header-accent: #0a6ed1;
    --cs-grid-border: #dcdcdc; --cs-cell-border: rgba(0,0,0,0.05);
    --cs-group1-bg: #f4f4f4;   --cs-group2-bg: #e6e6e6;  --cs-group2-fg: #32363a;
    --cs-zebra-bg: #fafafa;
    --cs-chip-border: #d9d9d9;
    --cs-info-bg: #eaeaea;
    --cs-accent: #0a6ed1;
    --cs-scroll-thumb: rgba(10,110,209,0.30); --cs-scroll-hover: rgba(10,110,209,0.55);
}

/* ---- style5f (Claude / macOS chat): тёплый oat/cream + clay-коралл ---------- */
body.cscheme-style5f {
    --cs-topbar-bg: #EDE9E0;   --cs-topbar-fg: #3D3D3A;   --cs-topbar-accent: #C15F3C;
    --cs-topbar-border: #D97757;   /* тонкая clay-линия снизу топбара — подпись Claude */
    --cs-page-bg: #FAF9F5;
    --cs-icon: #C15F3C;        --cs-title: #3D3D3A;
    --cs-badge-bg: #D97757;    --cs-badge-fg: #ffffff;
    --cs-header-bg: #F0EEE6;   --cs-header-fg: #3D3D3A;
    --cs-header-border: #E3DED2; --cs-header-accent: #D97757;
    --cs-grid-border: #E7E2D6; --cs-cell-border: rgba(61,61,58,0.06);
    --cs-group1-bg: #F5F3EC;   --cs-group2-bg: #EBE6DA;  --cs-group2-fg: #3D3D3A;
    --cs-zebra-bg: #FBFAF6;
    --cs-chip-border: #E3DED2;
    --cs-info-bg: #F1EDE3;
    --cs-accent: #D97757;
    --cs-act-tint-pct: 10%; --cs-act-tint-hover-pct: 18%;   /* IE 2026 11 03 / ODOO-350449 (webscm #128539: контраст «Лёгкого тона» — текст ≥ 4,6, заливка отличима, без рамки): 9 % — 1,065 в тёмной теме, чуть ниже Classic 9 % (1,069); 10 % — 1,07 */
    --cs-accent-soft: color-mix(in srgb, #D97757 16%, #fff);
    --cs-scroll-thumb: rgba(217,119,87,0.32); --cs-scroll-hover: rgba(217,119,87,0.55);
}

/* ---- style6m (McDonald's app): белый фон, жёлтый акцент, красные бейджи ----- */
/* IE 2026 08 23 (заказ Игоря, скрины приложения McDonald's) */
/* IE 2026 09 04 / ODOO-336291 (mobile UX): --cs-on-accent — цвет текста/иконок НА акценте. В style6m акцент #FFBC0D светлый: белый на нём
   даёт контраст 1.7:1, тёмный #292929 ≈ 11:1; в остальных гаммах — белый, как было. Читает mobile-ui.css */
body[class*="cscheme-style"] { --cs-on-accent: #ffffff; }
body.cscheme-style6m {
    --cs-on-accent: #292929;
    --cs-topbar-bg: #FFFFFF;   --cs-topbar-fg: #292929;   --cs-topbar-accent: #DA291C;
    --cs-topbar-border: #FFBC0D;   /* фирменная жёлтая линия под топбаром */
    --cs-page-bg: #F5F5F4;
    --cs-icon: #DB9C00;        --cs-title: #292929;
    --cs-badge-bg: #DA291C;    --cs-badge-fg: #ffffff;
    --cs-header-bg: #ffffff;   --cs-header-fg: var(--cs-muted); /* IE 2026 08 23: белые шапки, как в 2o */
    --cs-header-border: #ECECEC; --cs-header-accent: #E3E3E3;
    --cs-grid-border: #E8E8E8; --cs-cell-border: rgba(41,41,41,0.06);
    --cs-group1-bg: #F7F7F7;   --cs-group2-bg: #EFEFEF;  --cs-group2-fg: #292929;
    --cs-zebra-bg: #FAFAFA;
    --cs-chip-border: #E8E8E8;
    --cs-info-bg: #FFF6DF;
    --cs-accent: #FFBC0D;
    --cs-accent-text: #B37B00;   /* IE 2026 11 02 / ODOO-350449 (ревью webscm #125869): жёлтый акцент на белом 1,7:1 — подписи кнопок опций в покое тёмно-золотым */
    --cs-act-tint-pct: 15%; --cs-act-tint-hover-pct: 30%;   /* IE 2026 11 03 / ODOO-350449 (webscm #128539: контраст «Лёгкого тона» — текст ≥ 4,6, заливка отличима, без рамки): жёлтый 9 % — 1,05 / 1,04 к подложке; 15 % — 1,09 / 1,07 (уровень Classic 9 %) */
    /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: p229 натиснуті кнопки опцій — м'яка підкладка замість інверсії): литерал вместо var(--cs-panel-btn) — общее правило body[class*=cscheme-style] { --cs-panel-btn: var(--cs-accent) } стоит НИЖЕ с той же
       специфичностью и перебивает --cs-panel-btn гаммы: замер dev02 -148 — подпись нажатой в 6m шла жёлтым 0,65×#FFBC0D */
    --cs-accent-soft: color-mix(in srgb, #FFBC0D 22%, #fff);
    --cs-muted: #6E6E73;
    --cs-panel-btn: #B37B00;   /* иконки-команды: тёмно-золотой, читается на белом */
    --cs-scroll-thumb: rgba(255,188,13,0.45); --cs-scroll-hover: rgba(219,156,0,0.65);
}

/* ---- style7w (Star Wars): космос, жёлтый титр, голубой луч ------------------ */
/* IE 2026 09 14 / ODOO-… (заказ Игоря: схемы иконок): цветовая гамма 7w; схема иконок 7w — отдельная настройка (ischeme-style7w) */
body.cscheme-style7w {
    --cs-on-accent: #111111;
    --cs-topbar-bg: #0B0D12;   --cs-topbar-fg: #FFE81F;   --cs-topbar-accent: #4FC3F7;
    --cs-topbar-border: #FFE81F;   /* жёлтая линия титров под топбаром */
    --cs-page-bg: #ECEEF3;
    --cs-icon: #1F7ACC;        --cs-title: #14171F;
    --cs-badge-bg: #E3262E;    --cs-badge-fg: #ffffff;   /* красный — тревога (ситхи) */
    --cs-header-bg: #1C2130;   --cs-header-fg: #E6E9F2;  /* имперская консоль: тёмные шапки, светлый текст */
    --cs-header-border: #2F3648; --cs-header-accent: #FFE81F;
    --cs-grid-border: #D5D9E3; --cs-cell-border: rgba(20,23,31,0.07);
    --cs-group1-bg: #E3E6EE;   --cs-group2-bg: #D2D7E3;  --cs-group2-fg: #14171F;
    --cs-zebra-bg: #F4F5F8;
    --cs-chip-border: #C9CFDC;
    --cs-info-bg: #FFF8C6;
    --cs-accent: #FFE81F;
    --cs-accent-text: #1F7ACC;   /* IE 2026 11 02 / ODOO-350449 (ревью webscm #125869): жёлтый титр на белом 1,25:1 — подписи кнопок опций в покое голубым луча */
    --cs-act-tint-pct: 26%; --cs-act-tint-hover-pct: 60%;   /* IE 2026 11 03 / ODOO-350449 (webscm #128539: контраст «Лёгкого тона» — текст ≥ 4,6, заливка отличима, без рамки): жёлтый титр 9 % — 1,02 / 1,02 (сливался в обеих темах); 26 % — 1,07 / 1,09; наведение 60 % — шаг к покою как у Classic 16/9 */
    /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: p229 натиснуті кнопки опцій — м'яка підкладка замість інверсії): литерал — см. 6m (общее правило ниже перебивает --cs-panel-btn гаммы) */
    --cs-accent-soft: color-mix(in srgb, #FFE81F 30%, #fff);
    --cs-muted: #4B5263;
    --cs-panel-btn: #1F7ACC;   /* иконки-команды: голубой луч, читается на белом */
    --cs-scroll-thumb: rgba(255,232,31,0.55); --cs-scroll-hover: rgba(31,122,204,0.60);
}

/* ---- Правила топбара/фона — общие для всех гамм (кроме classic) ------------- */
body[class*="cscheme-style"] .layout-topbar {
    background: var(--cs-topbar-bg);
    color: var(--cs-topbar-fg);
    border-bottom: 2px solid var(--cs-topbar-border);
}
body[class*="cscheme-style"] .layout-topbar .p-link,
body[class*="cscheme-style"] .layout-topbar .layout-topbar-button {
    color: var(--cs-topbar-fg);
}
body[class*="cscheme-style"] .layout-topbar .layout-topbar-button:hover,
body[class*="cscheme-style"] .layout-topbar .p-link:hover {
    color: var(--cs-topbar-accent);
}
body[class*="cscheme-style"] .layout-wrapper,
body[class*="cscheme-style"] .main-container {
    background-color: var(--cs-page-bg);
}
/* PrimeVue primary-color = бренд схемы: разом перекрашивает иконки левого меню
   (_main.scss: color:var(--primary-color)), ссылки, активные состояния, акценты
   чата и т.п. — главный рычаг против «индиго везде». */
body[class*="cscheme-style"] {
    --primary-color: var(--cs-accent);
    /* именованные роли: приглушённый текст (тайтлы, шапки) и цвет кнопок
       командных панелей — управляются точечно из палитры схемы */
    --cs-muted: #64748B;
    --cs-panel-btn: var(--cs-accent);
}
/* IE 2026 10 02 / ODOO-343343 (заказ Игоря: фон белый, штриховка и флаг — цветом бордюра): капсула начала плана — подложка БЕЛАЯ во всех гаммах (--plan-start-ground; токен и читатели — единая точка переключения), а штрихи, флажок и рамка — ОДИН цвет,
   цвет разделителей шапки таблицы из гаммы (--cs-header-border; --plan-start-color = --plan-start-frame). classic: разделителей нет — #A3B6BE, как и было. График и мини-ганты читают эти же токены с body */
/* IE 2026 10 02 / ODOO-343343 (заказ Игоря: фон белый, штриховка и флаг — цветом бордюра): --plan-start-text — ПРЕЖНИЙ цвет капсулы (classic #A3B6BE; style*: текст шапки --cs-header-fg; style3k / style7w: фон шапки) для ТЕКСТА,
   который должен читаться: подпись месяца факта у Ганта движений (AttrGanttMoves). Светлым цветом бордюра текст не рисуем */
/* IE 2026 10 12 / ODOO-343343 (заказ Игоря: контраст капсулы в светлых схемах) */
/* Штрихи и флажок (--plan-start-color) = цвет разделителей шапки с подмесью текста шапки (--cs-header-fg) на --plan-start-mix: у светлых схем контраст штрихов с белым был 1,2–2,1:1, стал >= 3:1
   (1c / 4s / 5f / classic — 60 %, у 2o / 6m текст шапки сам светлее — 80 %; тёмные схемы 3k / 7w и так >= 6,8:1 — подмеси нет, 0 %). Рамка (--plan-start-frame) и текст (--plan-start-text) — прежние. Чистый CSS color-mix(), без JS-флага */
body { --plan-start-color: color-mix(in srgb, #A3B6BE, #3b4b52 60%); --plan-start-frame: #A3B6BE; --plan-start-ground: #fff; --plan-start-text: #A3B6BE; }
body[class*="cscheme-style"] { --plan-start-mix: 60%; --plan-start-color: color-mix(in srgb, var(--cs-header-border, #e6ebee), var(--cs-header-fg, #64748B) var(--plan-start-mix)); --plan-start-frame: var(--cs-header-border, #e6ebee); --plan-start-text: var(--cs-header-fg, #64748B); }
body.cscheme-style2o, body.cscheme-style6m { --plan-start-mix: 80%; }
body.cscheme-style3k, body.cscheme-style7w { --plan-start-text: var(--cs-header-bg); --plan-start-mix: 0%; }
/* IE 2026 09 30 / ODOO-343343 (заказ Игоря: элемент Plan start одинаковый во всех формах): ОБЩИЙ стиль «капсулы» начала плана — таблица (AttrGrid: верх — маска шапки .ps-cap-top, низ — полоса тела .ps-cap-bottom), Гант движений (AttrGanttMoves: то же);
   график и мини-ганты рисуют её SVG-ом (src/utils/planStartCapsule.js, те же числа: рамка 1 px, радиус 4, отступ 2, шаг штрихов 7, штрих 2, ширина 15, зона флажка 17).
   Белая подложка (в тёмной теме её инвертирует filter всего приложения), рамка — приглушённый цвет токена, штрихи — только внутри (clip content-box), начало рисунка — border-box. */
.ps-cap {
    box-sizing: border-box;
    border: 1px solid var(--plan-start-frame, #A3B6BE);   /* IE 2026 09 30 / ODOO-343343 (заказ Игоря: цвет разделителя — как рамки и текст шапки): рамка — токен body (разделители шапки), не смесь с белым */
    border-radius: 4px;
    padding: 17px 2px 2px;
    background-color: var(--plan-start-ground, #fff);   /* IE 2026 10 02 / ODOO-343343 (заказ Игоря: фон белый, штриховка и флаг — цветом бордюра): подложка — токен, белая во всех гаммах */
    background-image: repeating-linear-gradient(135deg, var(--plan-start-ground, #fff) 0 5px, var(--plan-start-color, #7b1fa2) 5px 7px), linear-gradient(var(--plan-start-ground, #fff), var(--plan-start-ground, #fff));
    background-repeat: no-repeat;
    background-origin: border-box;
    background-clip: content-box, padding-box;
}
.ps-cap.ps-cap-top { border-bottom-width: 0; border-radius: 4px 4px 0 0; padding: 17px 2px 0; }
.ps-cap.ps-cap-bottom { border-top-width: 0; border-radius: 0 0 4px 4px; padding: 0 2px 2px; }
.ps-cap.ps-cap-plain { background-image: none; }   /* верх без штрихов: вся шапка — зона флажка (Гант: шапка 21 px) */
.ps-flag {
    position: absolute; left: 0; right: 0; top: 2px; height: 15px;
    display: flex; align-items: center; justify-content: center;
    color: var(--plan-start-color, #7b1fa2); font-size: 12px; line-height: 1;
}
/* иконки-кнопки командных панелей — в унисон акценту стиля */
body[class*="cscheme-style"] .p-button-white {
    color: var(--cs-panel-btn) !important;
}
/* кнопки командной панели — в унисон акценту стиля (как рамка активного
   виджета); текст заголовка виджета — приглушённый серый (прежний цвет кнопок) */
body[class*="cscheme-style"] .commandPanel-buttons {
    background-color: var(--cs-accent);
}
body[class*="cscheme-style"] .widget-container {
    color: var(--cs-muted);
}
/* иконки левого блока — прямой оверрайд на случай хардкод-цвета (не через var) */
body[class*="cscheme-style"] .layout-sidebar li a i:not(.p-menu-white),
body[class*="cscheme-style"] .layout-sidebar li a svg,
body[class*="cscheme-style"] .layout-sidebar .menu-item svg,
body[class*="cscheme-style"] .layout-sidebar .menu-item .pi {
    color: var(--cs-icon);
}
/* заголовок рабочей области живёт В топбаре — контраст с его фоном (на тёмных (IE 2026 11 02 / ODOO-349799 (workspace-wording))
   схемах --cs-title тёмный и терялся); заголовки виджетов — на светлой странице */
body[class*="cscheme-style"] .workspace-title {
    color: var(--cs-topbar-fg);
}
body[class*="cscheme-style"] .widget-header {
    color: var(--cs-title);
}
/* иконки топбара база/процесс-модель/user (.logo_pi) — были серые
   (--text-color-secondary), плохо читались на цветном топбаре → topbar-fg.
   Кроме warning-состояния (.no-current-process_model, амбер) — его не трогаем. */
body[class*="cscheme-style"] .layout-topbar .logo_pi:not(.no-current-process_model) {
    color: var(--cs-topbar-fg);
}
/* тексты базы/процесс-модели/меню в правой части топбара — в тон топбару
   (db-chip и process-model-title используют тёмный --text-color) */
body[class*="cscheme-style"] .layout-topbar .process-model-title:not(.no-current-process_model),
body[class*="cscheme-style"] .layout-topbar .db-chip,
body[class*="cscheme-style"] .layout-topbar .topbar-right-2 .wj-menu {
    color: var(--cs-topbar-fg);
}
body[class*="cscheme-style"] .layout-topbar .db-chip:hover {
    color: var(--cs-topbar-accent);
}
/* пейджи (page-флайаут): неактивные пилюли были лавандовыми #d1d8f9 с серым
   тайтлом — не в тон схемы. Неактивная — светлый бренд-тинт + бренд-тайтл;
   hover — насыщенный акцент; бейдж-счётчик пейджа — акцент.
   Активная пилюля уже .widget-button-active = var(--cs-accent). */
body[class*="cscheme-style"] .page-hover-label {
    background-color: color-mix(in srgb, var(--cs-accent) 16%, #fff) !important;
    color: var(--cs-title) !important;
}
@media (hover: hover) { /* IE 2026 09 04 / ODOO-336291 (mobile UX): P-25 — ховер только курсору (на таче залипал после тапа, B-30) */
body[class*="cscheme-style"] .workspace-pages:hover .left-area-button-tab:hover .page-hover-label {
    background-color: var(--cs-accent) !important;
    color: #fff !important;
}
}
body[class*="cscheme-style"] .page-badge {
    color: var(--cs-accent) !important;
}
/* квадрат-подложка иконки НЕактивного пейджа (.left-area-button-tab) была
   лавандовой #6476ef3e, а сама иконка индиго → светлый бренд-тинт + иконка
   в --cs-icon. Активный пейдж (.widget-button-active) — насыщенный акцент. */
body[class*="cscheme-style"] .left-area-button-tab:not(.widget-button-active) {
    background-color: color-mix(in srgb, var(--cs-accent) 20%, #fff) !important;
}
/* IE 2026 10 12 / ODOO-5800 (заказ Игоря, скрин рейла DM 12.10): текстовая плашка страницы
   (.rowPage-placeholder — код вместо иконки, «M1A», «M2») наследовала белый цвет кнопки и
   терялась на светлой подложке; красим тем же --cs-icon, что и иконки */
body[class*="cscheme-style"] .left-area-button-tab:not(.widget-button-active) i,
body[class*="cscheme-style"] .left-area-button-tab:not(.widget-button-active) .rowPage-placeholder {
    color: var(--cs-icon);
}
/* фильтр/селектор-чипсы (топбар «Object:…» + шапка виджета «Main Supplier…»):
   тело было серым #dee2e6, левая иконка слейт #778899 → тело светлый бренд-тинт,
   левая иконка — насыщенный акцент. */
body[class*="cscheme-style"] .chip {
    background: color-mix(in srgb, var(--cs-accent) 14%, #fff);
}
body[class*="cscheme-style"] .chip-icon {
    background: var(--cs-accent);
}
/* ползунки скролла — в тон акцента схемы */
body[class*="cscheme-style"] *::-webkit-scrollbar-thumb {
    background: var(--cs-scroll-thumb);
}
body[class*="cscheme-style"] *::-webkit-scrollbar-thumb:hover {
    background: var(--cs-scroll-hover);
}
/* колонки meta (.cell-info) — нейтральный тон в тон схемы */
body[class*="cscheme-style"] .wj-cell.cell-info {
    background-color: var(--cs-info-bg) !important;
}
/* Меню в топбаре (Widgets/Calc/More/workspace) — белый фон .wj-dropdown ломал
   гамму топбара. Делаем прозрачным: меню наследует цвет топбара, текст — topbar-fg.
   Раскрытый попап (.wj-dropdown-panel/listbox) — отдельный элемент, остаётся белым. */
body[class*="cscheme-style"] .topbar .wj-dropdown,
body[class*="cscheme-style"] .topbar .wj-dropdown .wj-form-control,
body[class*="cscheme-style"] .topbar .wj-dropdown .wj-input,
body[class*="cscheme-style"] .topbar .wj-dropdown .wj-input-group {
    background: transparent !important;
    color: var(--cs-topbar-fg);
    border-color: color-mix(in srgb, var(--cs-topbar-fg) 25%, transparent);
}
/* «Пейджи»/табы виджета (.wj-tabheaders) — белый фон наследует тон страницы,
   а не выбивается стерильным белым. Активный таб держит акцент (низ-бордер). */
body[class*="cscheme-style"] .wj-tabpanel,
body[class*="cscheme-style"] .wj-tabheader.wj-state-active {
    background-color: transparent !important;
}
/* IE 2026 08 25 / ODOO-… (скрин Игоря): .wj-tabheaders — sticky (top:0, z:100);
   прозрачный фон просвечивал контент при прокрутке формы — строки наезжали на меню
   табов. Виджеты во всех гаммах белые (.WIDGET { background: white }), поэтому
   непрозрачный белый визуально тот же, но перекрывает контент под sticky-строкой. */
body[class*="cscheme-style"] .wj-tabheaders {
    background-color: #ffffff !important;
}
/* сегмент-пилюля виджета (DS/R/W-Space и т.п.) — бренд вместо индиго #8ea0ff */
body[class*="cscheme-style"] .segment-title {
    background: var(--cs-accent);
}
/* выделенная вкладка внутри виджета: текст (был индиго #647eff) и подчёркивание
   (было оранжевое) — в тон акценту схемы */
body[class*="cscheme-style"] .wj-tabpanel>div>.wj-tabheaders>.wj-tabheader.wj-state-active {
    color: var(--cs-accent);
}
body[class*="cscheme-style"] .wj-tabpanel>div>.wj-tabheaders>.wj-tabheader:after {
    background: var(--cs-accent);
}
/* range-selector графика (навигатор): окно выбора и ручки — в тон акценту схемы
   (были серые #bdbdbd/#d3d3d3). Окно — мягкий тинт, ручки — насыщенный акцент. */
body[class*="cscheme-style"] .wj-rangeslider-rangehandle {
    background-color: color-mix(in srgb, var(--cs-accent) 22%, transparent) !important;
}
body[class*="cscheme-style"] .wj-rangeslider-minhandle,
body[class*="cscheme-style"] .wj-rangeslider-maxhandle {
    background-color: var(--cs-accent) !important;
}
/* бейджи-счётчики — в тон бренду. Реальный класс в тулбаре/табах — .badge
   (хардкод rgba(100,119,239,.6)/#6477ef9e в нескольких компонентах), плюс .p-badge */
body[class*="cscheme-style"] .badge {
    background-color: var(--cs-badge-bg) !important;
    color: var(--cs-badge-fg) !important;
}
body[class*="cscheme-style"] .p-badge {
    background: var(--cs-badge-bg);
    color: var(--cs-badge-fg);
}
/* ==== /Цветовые гаммы ======================================================= */
.widget-15 {
    display: flex;
    height: 100%;
    width: 100%;
    padding-bottom: 3px;
}
.widget-12 {
    height: 100%;
    width: 100%;
}

.mr-0 {
    margin-right: 0px !important;
}
*, *::before, *::after {
    box-sizing: border-box;
}

.layout-sidebar::-webkit-scrollbar {
    width: 0px;
}
.layout-sidebar::-webkit-scrollbar-track {
    border-radius: 0.25rem;
    background: rgba(0, 0, 0, 0);
}

*::-webkit-scrollbar {
    width: 9px;
    height: 9px;
}

*::-webkit-scrollbar-track {
    border-radius: 0.25rem;
    background: rgba(0, 0, 0, 0.1);
}
*::-webkit-scrollbar-thumb {
    border-radius: 0.25rem;
    background: rgba(0, 0, 0, 0.2);
}

*::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.4);
}
*::-webkit-scrollbar-thumb:active {
    background: rgba(0, 0, 0, 0.9);
}

html,
body {
    height: 100%;
}
/* IE 2026 11 02 / ODOO-350449 (заказ Игоря: p215 єдиний шрифт для нативних кнопок і полів): шрифт интерфейса — одной переменной (body и правило ниже) */
:root { --ie-ui-font: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Ubuntu, 'Helvetica Neue', sans-serif; }
body {
    background-color: #f7faff;
    font-size: 0.875rem;
    font-family: var(--ie-ui-font);   /* IE 2026 11 02 / ODOO-350449 (заказ Игоря: p215 єдиний шрифт для нативних кнопок і полів) */
    padding: 0;
    margin: 0;
    flex-direction: column;
    overflow: hidden !important;
}
/* IE 2026 11 02 / ODOO-350449 (заказ Игоря: p215 єдиний шрифт для нативних кнопок і полів): засечки и Arial в полосах команд / опций.
   Причина (замер dev02): (1) кнопка-глиф с подписью (class="pi pi-folder-open" + <span>Записи</span>: AttrButton, кнопки опций / видов,
   «+ Сегмент» в шапке грида) — .pi ставит font-family primeicons самой кнопке, подпись его наследует, а в primeicons нет букв — браузер
   рисует их запасным шрифтом с засечками; (2) нативные button / input / select / textarea без своего класса шрифта берут шрифт браузера
   (Arial 13 px), а не шрифт интерфейса. Правило: подписи внутри .pi — шрифт интерфейса (сам глиф ::before и вложенные иконки .pi не
   трогаем); нативным полям — font-family родителя (размер не трогаем: классы компонентов и PrimeVue .p-component задают свой). */
/* IE 2026 11 02 / ODOO-350449 (ревью webscm #125869): выключатель fe.ux.uiFontUnify (класс .ui-font-unify на layout-wrapper, дефолт ВКЛ; ВЫКЛ — шрифты как до p215) */
/* IE 2026 11 02 / ODOO-350449 (регрессия боя -132, webscm #125935): класс флага поднял специфичность (0,1,1) выше .pi (0,1,0) — у кнопок с pi на самом button (.commandPanel-buttons, hdr-cmd)
   ::before получал system-ui вместо primeicons, иконки — пустые прямоугольники. :where() обнуляет вес класса флага: специфичность снова 0,0,1, как у
   исходного правила p215 (`button { font-family: inherit }`), .pi побеждает. Второе правило — для подписей ВНУТРИ .pi, иконки не задевает */
:where(.ui-font-unify) button, :where(.ui-font-unify) input, :where(.ui-font-unify) select, :where(.ui-font-unify) textarea { font-family: inherit; }
.ui-font-unify .pi > :not(.pi):not([class*="pi-"]) { font-family: var(--ie-ui-font); }

.button {
    cursor: pointer;
}

#app {
    flex: 1 1 auto;
    /* clip, а не hidden: hidden оставляет элемент программно-прокручиваемым, и
       браузерный фокус-скролл (scrollIntoView при фокусе виджета во время загрузки,
       пока транзиентный overflow скелетов R10) угонял scrollTop и залипал — вся
       страница уезжала вверх (виджеты-«обрубки» в тёмной теме). #app по дизайну
       не скроллится никогда (скролл страницы — window) */
    overflow: clip;
}

.hr {
    width: 1px;
    height: 100%;
    position: relative;
    background: #e4ecfb;
    z-index: 1;
}
.hr::before {
    content: '';
    display: block;
    width: 1px;
    height: 100%;
    background-color: #f6f9fe;
}

.menu {
    display: flex;
    flex-direction: column;
    font-size: 0.85rem;
    justify-content: flex-start;
    flex: 0 0 auto;
    padding: 0;
}
@media only screen and (max-width: 840px), (max-height: 840px) {
    .menu {
        overflow: auto;
        font: 0.75rem;
    }
}
.menu.menu--open .menu-item-name {
    display: block;
}

.menu-toggle {
    transition: all 500ms;
    padding: 1rem;
    text-align: center;
    border-bottom: 1px solid #e6ecf1;
    cursor: pointer;
}

.menu-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0.5rem 1rem;
    cursor: pointer;
    user-select: none;
    position: relative;
    text-align: left;
}
.menu-item:hover {
    background: #f7faff;
}
.menu-item:hover:before {
    content: '';
    display: inline-block;
    width: 1rem;
    height: 1rem;
    bottom: 2rem;
    left: 2.5rem;
    position: absolute;
    background: linear-gradient(#fff, #fff), linear-gradient(#fff, #fff), #0085c7;
    background-position: center;
    background-size: 50% 2px, 2px 50%; /*thickness = 2px, length = 50% (25px)*/
    background-repeat: no-repeat;
    border-radius: 50%;
    box-shadow: 0 1px 2px rgba(55, 63, 66, 0.07), 0 2px 4px rgba(55, 63, 66, 0.07), 0 4px 8px rgba(55, 63, 66, 0.07),
    0 8px 16px rgba(55, 63, 66, 0.07), 0 16px 24px rgba(55, 63, 66, 0.07), 0 24px 32px rgba(55, 63, 66, 0.07);
}
.menu-item-name {
    margin: 0 0.5rem 0 1rem;
    white-space: nowrap;
    display: none;
}
@media only screen and (max-width: 840px), (max-height: 840px) {
    .menu-toggle {
        padding: 1rem 0;
    }
    .menu-item {
        padding: 0.5rem;
    }
    .menu-item:hover:before {
        bottom: 1rem;
        left: 1rem;
    }
    .menu-item svg {
        width: 32px;
        height: 32px;
    }
}

.menu .menu-toggle svg {
    transition: all 250ms ease-out 50ms;
    transform-origin: center center;
    transform: scaleX(1);
}
.menu.menu--open .menu-toggle svg {
    transform: scaleX(-1);
}

.blank {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    justify-content: center;
    text-align: center;
}
.blank svg {
    width: 3rem;
    height: 3rem;
    margin-bottom: 1rem;
}

.widget_workspace {
    border-style: dashed;
    border-color: lightgray;
    box-shadow: none;
}

.WIDGET {
    position: absolute;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    overflow: visible; /* >> resizer-top */
    /* АН 2026 08 15 / ODOO-4997 (Игорь п.12): каждый виджет — СВОЙ stacking
       context: z-index детей (notification-плашка z:120, панели z:100) живут
       внутри виджета и не вылезают поверх СОСЕДНИХ виджетов — докнутые
       виджеты идут с z:auto (порядок DOM), и без изоляции плашка заднего
       виджета рисовалась поверх переднего */
    isolation: isolate;
    page-break-inside: avoid; /* important when printing the WORKSPACE */
    border-radius: 0.5rem;
    box-sizing: border-box;
    transition: all 200ms;

    background: white;
    box-shadow: 0 1px 2px rgba(55, 63, 66, 0.07), 0 2px 4px rgba(55, 63, 66, 0.07), 0 4px 8px rgba(55, 63, 66, 0.07),
    0 8px 16px rgba(55, 63, 66, 0.07), 0 16px 24px rgba(55, 63, 66, 0.07), 0 24px 32px rgba(55, 63, 66, 0.07);
}

/* восстановление после soft-close: держит виджет скрытым, пока остальные
   виджеты доезжают на новые места (transition: all 200ms); !important —
   чтобы перебить inline display от v-show */
.WIDGET.widget-restoring {
    display: none !important;
}

.widget-pop-out {
    position: fixed; /* или absolute, но fixed обычно удобнее для pop_out */
    /* left/top/width/height из computed */
    user-select: none;

    /* геометрию НЕ анимировать (у .WIDGET transition: all 200ms):
       иначе popout «едет» от старой/нулевой позиции при (пере)открытии
       и любых применениях ректа — показываем сразу в нужном месте */
    transition: box-shadow 200ms, background-color 200ms, opacity 200ms;

    box-shadow:
        0 10px 30px rgba(0, 0, 0, 0.20),
        0 4px 12px rgba(0, 0, 0, 0.12);
}

.widget-pop-out.is-popout-moving {
  cursor: grabbing;
}
.widget-pop-out .popout-grab-zone {
  position: absolute;
  inset: 0;
  pointer-events: none; /* по умолчанию не перехватывает клики */
}

/* Полоса сверху как невидимый хедер (если хочешь) */
.popout-grab-top {
    position: absolute;
    left: 0; right: 0; top: -9px;
    height: 50px;
    cursor: grab;
    pointer-events: auto;
}

/* 8 ресайз-хэндлов */
.widget-pop-out .resize-handle {
  position: absolute;
  width: 18px;
  height: 18px;
  background: transparent; /* можно сделать видно при hover */
  pointer-events: auto;
  touch-action: none; /* IE 2026 08 20 / ODOO-336291 (mobile UX): жест не уходит в скролл страницы */
  z-index: 11; /* ручки над контентом виджета — SVG перехватывал тапы */
}
.popout-grab-top {
  touch-action: none; /* IE 2026 08 20 / ODOO-336291 (mobile UX) */
}
/* IE 2026 09 06 / ODOO-335246 (Igor): боковые ручки заходят внутрь виджета только на 4 px — 18-px ручка на 9 px внутри
   ложилась ровно на нативную полосу прокрутки (9 px) гридов и диаграммы, и ползунок нельзя было потянуть мышью */
.widget-pop-out .h-n  { top:-14px; left:50%; transform:translateX(-50%); cursor: ns-resize; width: 30%; }
.widget-pop-out .h-s  { bottom:-14px; left:50%; width:90%; transform:translateX(-50%); cursor: ns-resize; }
.widget-pop-out .h-e  { right:-14px; top:50%; height:90%; transform:translateY(-50%); cursor: ew-resize; }
.widget-pop-out .h-w  { left:-14px; top:50%; height:90%; transform:translateY(-50%); cursor: ew-resize; }
.widget-pop-out .h-ne { right:-9px; top:-9px; cursor: nesw-resize; }
.widget-pop-out .h-nw { left:-9px; top:-9px; cursor: nwse-resize; }
.widget-pop-out .h-se { right:-9px; bottom:-9px; cursor: nwse-resize; }
.widget-pop-out .h-sw { left:-9px; bottom:-9px; cursor: nesw-resize; }

/*.widget-pop-out .resize-handle:hover {
  background: rgba(0,0,0,0.05);
}*/

/* ресайз docked-виджета за правый/нижний край (ит.3 п.3.4) */
.dock-resize-zone {
  position: absolute;
  inset: 0;
  pointer-events: none;
}
.dock-resize-zone .resize-handle {
  position: absolute;
  background: transparent;
  pointer-events: auto;  touch-action: none; /* IE 2026 08 20 / ODOO-336291 (mobile UX) */
  z-index: 11;
}
.dock-resize-zone .h-s  { bottom:-4px; left:0; width:calc(100% - 14px); height:8px; cursor: ns-resize; }
.dock-resize-zone .h-e  { right:-4px; top:0; height:calc(100% - 14px); width:8px; cursor: ew-resize; }
.dock-resize-zone .h-se { right:-4px; bottom:-4px; width:14px; height:14px; cursor: nwse-resize; }

.widget-inline {
    z-index: 900;
    cursor: pointer;
}
.widget-inline * {
    pointer-events: none;
}
.widget-inline:hover {
    filter: drop-shadow(2px 4px 6px black);
}
  
.WIDGET-2024-10 {
    position: relative;
    resize: both;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    margin: 7px 0px 0px 7px;
    height: 47vh;
    overflow: hidden;
    page-break-inside: avoid; /* important when printing the WORKSPACE */
    transition: all 1250ms;
    border-radius: 0.5rem;
    box-sizing: border-box;
    max-width: -webkit-fill-available;
    max-height: -webkit-fill-available;

    background: white;
    box-shadow: 0 1px 2px rgba(55, 63, 66, 0.07), 0 2px 4px rgba(55, 63, 66, 0.07), 0 4px 8px rgba(55, 63, 66, 0.07),
    0 8px 16px rgba(55, 63, 66, 0.07), 0 16px 24px rgba(55, 63, 66, 0.07), 0 24px 32px rgba(55, 63, 66, 0.07);
}
.popup-tab {
    resize: both;
    margin: 3px 0px 0px 3px;
    height: 47vh;
    border-radius: 0.5rem;

    background: white;
    box-shadow: 0 1px 2px rgba(55, 63, 66, 0.07), 0 2px 4px rgba(55, 63, 66, 0.07), 0 4px 8px rgba(55, 63, 66, 0.07),
    0 8px 16px rgba(55, 63, 66, 0.07), 0 16px 24px rgba(55, 63, 66, 0.07), 0 24px 32px rgba(55, 63, 66, 0.07);
}
/* IE 2026 09 17 / ODOO-… (заказ Игоря): подсказку можно поймать мышью и скопировать текст —
   класс wj-tooltip-my навешивается в момент показа, поэтому правило дублируем на сам .wj-tooltip */
.wj-tooltip {
    user-select: text;
    -webkit-user-select: text;
}
/* IE 2026 09 20 / ODOO-337259 (Игорь: «давай его скрывать затуханием через некое время»): затухание доживающей после Alt подсказки; класс снимает altTooltip
   (поймали курсором — возвращается сразу). Два класса — сильнее opacity !important у .wj-tooltip-my */
.wj-tooltip.alt-tip-fading {
    opacity: 0 !important;
    transition: opacity var(--alt-tip-fade-ms, 600ms) ease-in;
}
/* IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции): блок мер бейджа наведения карты / графа / потока затухает после отпускания Alt
   (пауза fe.data.altTooltipLingerGraceMs прошла): класс ставит computed badgeDetailsFading, длительность — inline transition-duration */
.attr-geomap-badge-ext.alt-details-fading, .attr-graph-badge-ext.alt-details-fading {
    opacity: 0;
    transition: opacity 600ms ease-in;
}
.wj-tooltip-my {
    background:#F6F9FC;
    border-radius: 0.5rem;
    opacity: .9 !important;
    pointer-events: auto !important;
    /* IE 2026 09 17 / ODOO-… (заказ Игоря): текст подсказки можно выделить и скопировать */
    user-select: text;
    -webkit-user-select: text;
    cursor: text;
}
/* IE 2026 09 23 / ODOO-… (заказ Игоря: кнопки в подсказках): блок кнопок-действий в подсказке (utils/tipActions.js) — компактные кнопки-иконки в строку под текстом,
   цвета — от самой подсказки (currentColor), подпись кнопки — стандартный title браузера */
.wj-tooltip .tip-actions { display: flex; align-items: center; gap: 2px; margin-top: 5px; padding-top: 4px; border-top: 1px solid rgba(0, 0, 0, .12); user-select: none; -webkit-user-select: none; }
.wj-tooltip .tip-btn { background: transparent; border: none; cursor: pointer; padding: 3px 7px; border-radius: 4px; color: inherit; opacity: .72; font-size: 12px; line-height: 1; display: inline-flex; align-items: center; }
.wj-tooltip .tip-btn:hover { opacity: 1; background: rgba(0, 0, 0, .08); }
/* IE 2026 09 26 / ODOO-… (замечание Игоря: «+» на новой странице) · p206b: недоступная кнопка подсказки (временная страница) — приглушена, без подсветки */
.wj-tooltip .tip-btn.tip-btn-disabled { opacity: .3; cursor: not-allowed; }
.wj-tooltip .tip-btn.tip-btn-disabled:hover { opacity: .3; background: transparent; }
.wj-tooltip .tip-btn i { font-size: 12px; }
/* IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2: «Edit description» / «Add description» под строками объяснения записи (админ) — кнопка с подписью */
.wj-tooltip .tip-help-actions { display: flex; margin-top: 3px; user-select: none; -webkit-user-select: none; }
.wj-tooltip .tip-help-actions .tip-btn { gap: 5px; padding: 3px 6px 3px 2px; }
.wj-tooltip .tip-help-actions .tip-btn span { font-size: 12px; }
/* IE 2026 09 25 / ODOO-… (заказ Игоря: форматирование строк из подсказки): кнопка «A» (цвет текста) — буква с чертой снизу, как на панели действий строки грида; полоса образцов (utils/tipFormat.js) —
   в том же блоке .tip-actions: шапка (что меняем · без цвета · назад), сетка 10 × 6 образцов палитры wj-color-picker, поле #rrggbb + ✓ */
.wj-tooltip .tip-btn .tip-fmt-a { font-weight: 700; font-size: 12px; line-height: 1; border-bottom: 2px solid currentColor; padding-bottom: 1px; font-family: Arial, Helvetica, sans-serif; }
.wj-tooltip .tip-actions.tip-fmt { flex-direction: column; align-items: stretch; gap: 4px; }
.wj-tooltip .tip-fmt-head { display: flex; align-items: center; gap: 2px; }
.wj-tooltip .tip-fmt-title { flex: 1 1 auto; font-size: 12px; font-weight: 600; color: #647eff; }
.wj-tooltip .tip-fmt-grid { display: grid; grid-template-columns: repeat(10, 14px); gap: 2px; }
.wj-tooltip .tip-swatch { width: 14px; height: 14px; padding: 0; border: 1px solid rgba(0, 0, 0, .25); border-radius: 2px; cursor: pointer; box-sizing: border-box; }
.wj-tooltip .tip-swatch:hover { outline: 2px solid #2997ff; outline-offset: 0; }
.wj-tooltip .tip-swatch.is-current, .wj-tooltip .tip-btn.tip-swatch-none.is-current { outline: 2px solid #333; outline-offset: 0; }
.wj-tooltip .tip-fmt-custom { display: flex; align-items: center; gap: 4px; }
.wj-tooltip .tip-fmt-hex { width: 76px; font: inherit; font-size: 12px; line-height: 1.2; padding: 1px 4px; border: 1px solid rgba(0, 0, 0, .25); border-radius: 3px; background: #fff; color: #333; }
.wj-tooltip .tip-fmt-hex.is-bad { border-color: #d9534f; }
/* IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2: подсказка с ОБЪЯСНЕНИЯМИ (элемента — .ui-help-title / .ui-help-text, записи — .ui-help-record) непрозрачна: общее правило
   .wj-tooltip-my держит opacity .9 — сквозь подсказку читался текст панели (клипы U1). Прочие подсказки платформы — как были; затухание после Alt не трогается */
.wj-tooltip:not(.alt-tip-fading):has(.ui-help-title, .ui-help-text, .ui-help-record) { opacity: 1 !important; }
/* IE 2026 09 25 / ODOO-… (замечание Игоря: многострочный диалог описания записи): переводы строк объяснения записи (многострочные поля диалога описания)
   видны в подсказке — строка записи переносится по \n, пробелы схлопываются как обычно */
.wj-tooltip .ui-help-record { white-space: pre-line; }
/* IE 2026 09 27 / ODOO-341407 (заказ Игоря 27.09: «в tooltip если язык не eng то дополнительно показывай название на англ»): английское имя рядом с переведённым
   в строке названия («Пункт меню: Фільтри · Filters», utils/tipEnName.js) — приглушённо: обычное начертание, прозрачнее значения */
.wj-tooltip .tip-en-name { font-weight: 400; opacity: .75; }
.tooltip-tab {
    padding-left: 10px;
}
.tooltip-header {
    color: #647eff;
    font-weight: bold;
}
.tooltip-header-1 {
    color: #647eff;
    font-weight: bold;
    font-size: xx-small;
}
.tooltip-text {
    color: grey;
    // line-height: 2;
}
.tooltip-number {
    display: inline-block;
    min-width: 70px;        /* чтобы числа красиво выравнивались колонкой */
    text-align: right;
    font-variant-numeric: tabular-nums; /* чтобы цифры не прыгали */
    color: grey;
}
.tooltip-number-value {
    display: inline-block;
}
.num-negative {
    color: red;
}

.date-year { font-weight: bold; }
/*.date-month { color: #34495e; } */
/*.date-day { color: #495057; } */
.date-time { font-weight: bold; font-style: italic; }
.date-seconds { font-style: italic; }
.date-milliseconds { font-size: 0.9em; font-style: italic; }

.json-array-key {
    color: #12826c !important;
    font-weight: bold;
    text-align: end;
    padding-right: 20px !important;
}
.json-key {
    font-stretch: ultra-condensed;
    color: white;
    background: #12826c;
    border-radius: 3px;
    padding-inline: 0.3rem;
    opacity: 0.75;
}
.json-key2 {
    color: #1d75b3 !important;
}
.json-value {
    color: #b76622;
}
.json-mask {
    color: #2e383c;
}
.pi-doc {
    color: #647eff !important;
    font-weight: bold;
}
.attr-doc-button {
    background: transparent !important;
    text-shadow: none !important;
}
.row-header {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    overflow: hidden;
}
.row-header .attr-doc-button {
    transition: opacity 200ms, color 200ms;
    opacity: 0;
    color: lightslategray !important;
    padding: 0 3px !important;
    min-width: unset !important;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px !important;
    font-size: 0.72rem;
}
.row-header:hover .attr-doc-button {
    opacity: 1;
}
.row-header .attr-doc-button:hover {
    color: #647eff !important;
}
.p-button-white {
    color: #64748B !important;
    background: #ffffff !important;
}
.row-header .p-button-white {
    background: #ffffff00 !important;
}
.p-button-yellow {
    color: #778899 !important;
    background-color: yellow !important;
}
.p-button {
    transition: background-color 0.2s ease, box-shadow 0.2s ease;
}
/*.p-button:active {
    box-shadow: inset 2px 2px 2px rgb(255 204 103) !important;
}*/
.p-button-active {
    background: #ffe5b5 !important
}
/* IE 2026 11 02 / ODOO-350449 (заказ Игоря: p219 опції й види — у стилі чипів глобального пошуку, кольором теми замість жовтого):
   кнопки опций и видов — как чипсы глобального поиска (.toggle-chip): в покое подпись цветом темы, нажатая — заливка цветом темы и светлый текст;
   янтарная .p-button-active и бледная --highlight-bg не используются. Цвет темы — тот, что у рамки активного виджета: --cs-accent схемы,
   в Classic — #647eff. Меняются только цвета (фон, текст, рамка) — размеры кнопок прежние. Выключатель fe.ux.optionChipsThemeColor
   (класс .opt-chips-theme на layout-wrapper; ВЫКЛ — прежние цвета). Охват: кнопки панелей виджета (AttrButton: опции шапки REPORT2,
   полоса видов и склеенные группы p191, segmented-btn), SegSwitch (p189: «Форма» и др.), HeatmapSwitches. */
.opt-chips-theme { --opt-accent: var(--cs-accent, #647eff); --opt-on-accent: var(--cs-on-accent, #ffffff); --opt-tint: color-mix(in srgb, var(--opt-accent) 12%, transparent); --opt-accent-text: var(--cs-accent-text, var(--opt-accent)); }   /* IE 2026 11 02 / ODOO-350449 (ревью webscm #125869): подпись в покое — --cs-accent-text схемы (жёлтые 6m / 7w: 1,7:1 и 1,25:1 на белом), иначе акцент */
/* покой: подписанные кнопки на белом фоне — подпись и глиф цветом темы (иконки без подписи остаются серыми); нажатые исключены явно —
   :has() поднимает специфичность выше правила нажатой (замер dev02 -123: текст нажатой был цветом темы на заливке темы) */
.opt-chips-theme .WIDGET .p-button.commandPanel-buttons.p-button-white:has(> span:not(:empty)):not(.p-button-active),
.opt-chips-theme .WIDGET .cp-item-wrap.cp-seg .p-button.commandPanel-buttons:not(.p-button-active),
.opt-chips-theme .WIDGET .p-button.commandPanel-buttons.segmented-btn:not(.p-button-active),
.opt-chips-theme .seg-set .seg-btn:not(.seg-on),
.opt-chips-theme .hm-btn:not(.hm-on) { color: var(--opt-accent-text) !important; }
.opt-chips-theme .WIDGET .p-button.commandPanel-buttons.p-button-white:has(> span:not(:empty)):not(.p-button-active):enabled:hover,
.opt-chips-theme .WIDGET .cp-item-wrap.cp-seg .p-button.commandPanel-buttons:not(.p-button-active):enabled:hover,
.opt-chips-theme .seg-set .seg-btn:not(.seg-on):hover:not(:disabled),
.opt-chips-theme .hm-btn:not(.hm-on):hover { background: var(--opt-tint) !important; }
/* нажата: заливка цветом темы, текст светлый, рамка — тем же цветом */
.opt-chips-theme .WIDGET .p-button.commandPanel-buttons.p-button-active,
.opt-chips-theme .WIDGET .p-button.commandPanel-buttons.p-button-active:enabled:hover,
.opt-chips-theme .seg-set .seg-btn.seg-on,
.opt-chips-theme .seg-set .seg-btn.seg-on:hover:not(:disabled),
.opt-chips-theme .hm-btn.hm-on,
.opt-chips-theme .hm-btn.hm-on:hover { background: var(--opt-accent) !important; color: var(--opt-on-accent) !important; border-color: var(--opt-accent) !important; }
.opt-chips-theme .seg-set .seg-btn.seg-on .seg-extra,
.opt-chips-theme .hm-btn.hm-on .hm-sort.hm-sort-on { color: inherit; }
/* IE 2026 11 03 / ODOO-350449 (заказ Игоря: p229 натиснуті кнопки опцій — м'яка підкладка замість інверсії):
   нажатая — как плитка страницы рейла (body[class*=cscheme-style] .left-area-button-tab: color-mix(акцент 20 %, белый)): светлая подложка в тон темы,
   подпись и глиф — цвет темы, затемнённый на 35 % (контраст на подложке >= 4,6:1 во всех 8 гаммах; в тёмной теме, invert(1), >= 6,6:1), «жирный» —
   обводкой глифа (-webkit-text-stroke): font-weight 600 расширил бы кнопку при нажатии. Рамка — цветом подложки, размеры прежние.
   Выключатель fe.ux.optionChipsSoftPressed (класс .opt-chips-soft на layout-wrapper; ВЫКЛ — заливка цветом темы выше). Специфичность на класс
   выше правил p219 и источник ниже — перебивает их !important */
.opt-chips-theme.opt-chips-soft { --opt-soft: color-mix(in srgb, var(--opt-accent) 20%, #fff); --opt-soft-hover: color-mix(in srgb, var(--opt-accent) 30%, #fff); --opt-soft-text: color-mix(in srgb, var(--opt-accent-text) 65%, #000); }   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: p229 натиснуті кнопки опцій — м'яка підкладка замість інверсії) */
.opt-chips-theme.opt-chips-soft .WIDGET .p-button.commandPanel-buttons.p-button-active,
.opt-chips-theme.opt-chips-soft .seg-set .seg-btn.seg-on,
.opt-chips-theme.opt-chips-soft .hm-btn.hm-on { background: var(--opt-soft) !important; color: var(--opt-soft-text) !important; border-color: var(--opt-soft) !important; -webkit-text-stroke: 0 !important; }   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: p234 прибрати жирність з натиснутих кнопок): нажатая — без «жирности» (обводки глифа), только подложка и цвет */   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: p229 натиснуті кнопки опцій — м'яка підкладка замість інверсії) */
.opt-chips-theme.opt-chips-soft .WIDGET .p-button.commandPanel-buttons.p-button-active:enabled:hover,
.opt-chips-theme.opt-chips-soft .seg-set .seg-btn.seg-on:hover:not(:disabled),
.opt-chips-theme.opt-chips-soft .hm-btn.hm-on:hover { background: var(--opt-soft-hover) !important; color: var(--opt-soft-text) !important; border-color: var(--opt-soft-hover) !important; -webkit-text-stroke: 0 !important; }   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: p229 натиснуті кнопки опцій — м'яка підкладка замість інверсії) */
/* IE 2026 11 03 / ODOO-350449 (заказ Игоря: лёгкий тон активных кнопок без рамки):
   включённая кнопка — лёгкий тон акцента схемы (доля — --cs-act-tint-pct гаммы, см. ниже; webscm #128539) вместо серой подложки p229; рамка — та же, что у
   невключённой (отдельной рамки акцентом нет), подпись — цветом невключённой (--opt-accent-text). Меняются только цвета: толщина рамки, отступы и
   жирность не трогаются — ширина кнопки прежняя. Тон — доля акцента поверх белого фона невключённой кнопки (как rgba 0,09 на белом; от
   цвета шапки виджета не зависит); в тёмной теме (invert(1) на корне) он ложится тем же малым тоном акцента темы на тёмный фон. Охват — те же три семьи, что у p219 / p229: AttrButton .p-button-active (опции шапки REPORT2, панель над таблицей,
   склеенные группы .cp-seg и .segmented-btn), SegSwitch .seg-btn.seg-on («Форма» и др.), HeatmapSwitches .hm-btn.hm-on.
   Выключатель fe.ux.activeButtonTint (класс .active-btn-tint на layout-wrapper; ВЫКЛ — серая подложка p229 выше). Специфичность равна правилам
   p229 (на hover — тоже), источник ниже — перебивает их !important */
/* IE 2026 11 03 / ODOO-350449 (webscm #128539): подпись --opt-accent-text на тоне давала 3,19 (Classic) … 2,39 (1c), а в 7w заливка сливалась с
   подложкой (1,02 в обеих темах). Подпись и глиф — --opt-act-fg = подпись невключённой, затемнённая до 60 % (наведение — 55 %): >= 5,2 к заливке
   в светлой и >= 7,1 в тёмной во всех 8 гаммах. Доля тона — --cs-act-tint-pct гаммы; по умолчанию 9 % / 16 % (утверждённый Игорем вид Classic);
   поднята только там, где заливка к подложке ниже уровня Classic 9 % (1,07 в обеих темах, тёмная — invert(1)): 1c 12/21, 5f 10/18, 6m 15/30,
   7w 26/60; наведение — 16 % или минимум с шагом к покою как у Classic 16/9. Рамка по-прежнему цветом тона. Расчёт: tint-contrast.txt (Odoo 350449) */
.opt-chips-theme.active-btn-tint { --opt-act-tint: color-mix(in srgb, var(--opt-accent) var(--cs-act-tint-pct, 9%), #fff); --opt-act-tint-hover: color-mix(in srgb, var(--opt-accent) var(--cs-act-tint-hover-pct, 16%), #fff); --opt-act-fg: color-mix(in srgb, var(--opt-accent-text) 60%, #000); --opt-act-fg-hover: color-mix(in srgb, var(--opt-accent-text) 55%, #000); --opt-act-line: var(--hm-line, var(--surface-border, #e1e4ec)); }   /* IE 2026 11 03 / ODOO-350449 (webscm #128539: контраст «Лёгкого тона» — текст ≥ 4,6, заливка отличима, без рамки) */
.opt-chips-theme.active-btn-tint .WIDGET .p-button.commandPanel-buttons.p-button-active,
.opt-chips-theme.active-btn-tint .seg-set .seg-btn.seg-on,
.opt-chips-theme.active-btn-tint .hm-btn.hm-on { background: var(--opt-act-tint) !important; color: var(--opt-act-fg) !important; border-color: transparent !important; -webkit-text-stroke: 0 !important; }   /* IE 2026 11 03 / ODOO-350449 (webscm #128539: контраст «Лёгкого тона» — текст ≥ 4,6, заливка отличима, без рамки) */
.opt-chips-theme.active-btn-tint .WIDGET .p-button.commandPanel-buttons.p-button-active:enabled:hover,
.opt-chips-theme.active-btn-tint .seg-set .seg-btn.seg-on:hover:not(:disabled),
.opt-chips-theme.active-btn-tint .hm-btn.hm-on:hover { background: var(--opt-act-tint-hover) !important; color: var(--opt-act-fg-hover) !important; border-color: transparent !important; -webkit-text-stroke: 0 !important; }   /* IE 2026 11 03 / ODOO-350449 (webscm #128539: контраст «Лёгкого тона» — текст ≥ 4,6, заливка отличима, без рамки) */
/* рамка — как у невключённой той же семьи: .p-button-border — lightgrey, без него — прозрачная (выше); склеенные группы, сегменты и теплокарта — линия группы */
.opt-chips-theme.active-btn-tint .WIDGET .p-button.commandPanel-buttons.p-button-active.p-button-border,
.opt-chips-theme.active-btn-tint .WIDGET .p-button.commandPanel-buttons.p-button-active.p-button-border:enabled:hover { border-color: var(--opt-act-tint) !important; }   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: у включённой кнопки рамка цветом тона — не видна) */
.opt-chips-theme.active-btn-tint .WIDGET .cp-item-wrap.cp-seg .p-button.commandPanel-buttons.p-button-active,
.opt-chips-theme.active-btn-tint .WIDGET .cp-item-wrap.cp-seg .p-button.commandPanel-buttons.p-button-active:enabled:hover,
.opt-chips-theme.active-btn-tint .WIDGET .p-button.commandPanel-buttons.segmented-btn.p-button-active,
.opt-chips-theme.active-btn-tint .WIDGET .p-button.commandPanel-buttons.segmented-btn.p-button-active:enabled:hover,
.opt-chips-theme.active-btn-tint .hm-btn.hm-on.hm-on,
.opt-chips-theme.active-btn-tint .hm-btn.hm-on.hm-on:hover { border-color: var(--opt-act-tint) !important; }   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: у включённой кнопки рамка цветом тона — не видна) */
.opt-chips-theme.active-btn-tint .seg-set .seg-btn.seg-on.seg-on,
.opt-chips-theme.active-btn-tint .seg-set .seg-btn.seg-on.seg-on:hover:not(:disabled) { border-color: var(--opt-act-tint) !important; }   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: у включённой кнопки рамка цветом тона — не видна) */
/* IE 2026 11 03 / ODOO-350449 (заказ Игоря: кнопка Σ і глаз — як інші кнопки опцій):
   Σ (p217, yearTotals_button: cssClass 'p-button-white yt-sigma' — без p-button-border и mr-1, которые есть у опций с бэка: 'pi p-button-white p-button-border mr-1')
   рисовалась без рамки и вплотную к соседу справа — рамка при наведении ложилась на него. Теперь — рамка lightgrey, зазор mr-1 (0,25rem), подпись в покое
   и тон наведения — как у подписанных опций p219; включённая — лёгкий тон с той же рамкой. Толщина рамки не меняется (1 px была прозрачной) — размер прежний.
   Выключатель fe.ux.headerOptionButtonsAlign (класс .hdr-opt-align на layout-wrapper; ВЫКЛ — как в p217) */
.hdr-opt-align .WIDGET .p-button.commandPanel-buttons.yt-sigma,
.hdr-opt-align .WIDGET .p-button.commandPanel-buttons.yt-sigma:enabled:hover { border-color: lightgrey !important; margin-right: 0.25rem !important; }
.hdr-opt-align.opt-chips-theme .WIDGET .p-button.commandPanel-buttons.yt-sigma:not(.p-button-active) { color: var(--opt-accent-text) !important; }
.hdr-opt-align.opt-chips-theme .WIDGET .p-button.commandPanel-buttons.yt-sigma:not(.p-button-active):enabled:hover { background: var(--opt-tint) !important; }
.hdr-opt-align.opt-chips-theme.active-btn-tint .WIDGET .p-button.commandPanel-buttons.p-button-active.yt-sigma,
.hdr-opt-align.opt-chips-theme.active-btn-tint .WIDGET .p-button.commandPanel-buttons.p-button-active.yt-sigma:enabled:hover { border-color: var(--opt-act-tint) !important; }   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: у включённой кнопки рамка цветом тона — не видна) */
/* IE 2026 11 03 / ODOO-350449 (заказ Игоря: у включённой кнопки рамка цветом тона — не видна): при наведении рамка — цветом тона наведения, иначе по краю светлое кольцо */
.opt-chips-theme.active-btn-tint .WIDGET .p-button.commandPanel-buttons.p-button-active:enabled:hover,
.opt-chips-theme.active-btn-tint .WIDGET .p-button.commandPanel-buttons.p-button-active.p-button-border:enabled:hover,
.opt-chips-theme.active-btn-tint .WIDGET .cp-item-wrap.cp-seg .p-button.commandPanel-buttons.p-button-active:enabled:hover,
.opt-chips-theme.active-btn-tint .WIDGET .p-button.commandPanel-buttons.segmented-btn.p-button-active:enabled:hover,
.opt-chips-theme.active-btn-tint .seg-set .seg-btn.seg-on.seg-on:hover:not(:disabled),
.opt-chips-theme.active-btn-tint .hm-btn.hm-on.hm-on:hover,
.hdr-opt-align.opt-chips-theme.active-btn-tint .WIDGET .p-button.commandPanel-buttons.p-button-active.yt-sigma:enabled:hover { border-color: var(--opt-act-tint-hover) !important; }   /* IE 2026 11 03 / ODOO-350449 */
/* IE 2026 11 03 / ODOO-350449 (заказ Игоря: Σ — висота й центр гліфа як у кнопок опцій):
   Σ был 31 px против 29,25 у «Палети»: глиф — блочный ::before (flex-элемент) 15 px с line-height 15 px, а у кнопок с .pi строка — line-height 1
   (12,25 px) шрифта primeicons плюс подпись шрифтом интерфейса (+1 px). Теперь у Σ та же модель строки: inline-block, line-height 1, primeicons;
   глиф — inline с line-height 0 (строку не раздвигает), пустая подпись — шрифтом интерфейса с zero-width space в ::after (+1 px, как у подписи
   «Палети»), сдвиг глифа 0,1em — центр с глазом. Проба p238e dev02: высота 29,25, Δ центра глифов Σ и глаза 0 px, наведение размер не меняет */
.hdr-opt-align .WIDGET .p-button.commandPanel-buttons.yt-sigma { display: inline-block; line-height: 1; font-family: primeicons; text-align: center; }
.hdr-opt-align .WIDGET .p-button.commandPanel-buttons.yt-sigma::before { display: inline-block; line-height: 0; font-family: var(--ie-ui-font, -apple-system, "Segoe UI", sans-serif); transform: translateY(0.1em); }
.hdr-opt-align .WIDGET .p-button.commandPanel-buttons.yt-sigma > span:empty { font-family: var(--ie-ui-font, -apple-system, "Segoe UI", sans-serif); }
.hdr-opt-align .WIDGET .p-button.commandPanel-buttons.yt-sigma > span:empty::after { content: '\200b'; }
.p-menu-white {
    color: #64748B !important;
}
.p-button-blue {
    color: #647eff !important;
    background: #ffffff !important;
    border: 1px solid #647eff !important;
}
.my-text-shadow {
    text-shadow:
        /* many shadows blur out the area around the text */
        0 0 1px white,
        0 0 2px white,
        0 0 3px white,
        0 0 4px white,
        0 0 5px white,
        0 0 6px white,
        0 0 7px white,
        0 0 8px white,
        0 0 9px white,
        0 0 10px white
}

@media only screen and (max-width: 10000px) {
    .WIDGET-2024-10 {
        width: calc(25% - 1rem);
    }
}
@media only screen and (max-width: 1599px) {
    .WIDGET-2024-10 {
        width: calc(33.33% - 1rem);
    }
}
@media only screen and (max-width: 1079px) {
    .WIDGET-2024-10 {
        width: calc(50% - 1rem);
    }
}
@media only screen and (max-width: 1023px) {
    .WIDGET-2024-10 {
        width: calc(100% - 1rem);
    }
}
// @media only screen and (max-height: 800px) {
//     .WIDGET-2024-10 {
//         max-height: 500px;
//     }
// }
.WIDGET-2024-10:only-child {
    height: 93vh;
}
.one-row-child .WIDGET-2024-10 {
    height: 93vh;
}
.WIDGET-2024-10:last-child {
    flex: 1 1 auto;
}
.widget-w1 {
    min-width: 20%;
}
.widget-w2 {
    min-width: 40%;
}
.widget-w3 {
    min-width: 65%;
}
.widget-w4 {
    min-width: -webkit-fill-available;
}
.widget-h0 {
    height: 40px;
}
.widget-h1 {
    height: 25vh;
}
.widget-h2 {
    height: 47vh;
}
.widget-h3 {
    height: 70vh;
}
.widget-h4 {
    height: 95vh;
}
.WIDGET:hover {
    border-color: #adb7bd;
}
.WIDGET.drag-over {
    border: 2px dashed #000;
}
.WIDGET .buttons {
    transition: all 250ms;
    opacity: 0;
    display: flex;
    align-items: center;
}
.WIDGET:hover .buttons {
    opacity: 1;
}
.widget-active .buttons {
    opacity: 1;
}
@media (hover: none) and (pointer: coarse) {
    .WIDGET .buttons {
        opacity: 1;
    }
}
.WIDGET .buttons > span {
    padding: 0 0.5rem;
    cursor: pointer;
}
.WIDGET.drag-over {
    border: 2px dashed #000;
    background-color: rgba(0, 0, 0, 0.1);
    transition: all 250ms;
}
.WIDGET.drag-source {
    opacity: 0.4;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    background-color: rgba(145, 200, 248, 0.75);
    transform: scale(0.9);
    transition: all 250ms;
}
/*
.WIDGET.enter {
    opacity: 0;
    transform: scale(0.9);
}
.WIDGET.enter-active {
    transition: opacity 0.5s, transform 0.5s;
    opacity: 1;
    transform: scale(1);
}
.WIDGET.leave-active {
    transition: opacity 0.5s, transform 0.5s;
    opacity: 0;
    transform: scale(0.9);
}
*/
.widget_workspace .widget-container {
    padding: 0.10rem 1rem;
    display: flex;
    align-items: center;
    /*cursor: grab;*/
}
.WIDGET .widget-container {
    border-bottom: 1px solid #e0e0e0;
    padding: 0.3rem 0 0.3rem 0.3rem;
    display: flex;
    align-items: center;
    /*cursor: grab;*/
}
.widget-container {
  pointer-events: none;
}
.widget-container > * {
  pointer-events: auto;
}

.WIDGET.widget-hide-header .widget-container { display: none !important; }
.WIDGET.widget-hide-tabs .wj-tabheaders      { display: none !important; }
.WIDGET.widget-hide-gridpanel .grid-top-line { display: none !important; }
.WIDGET .widget-header {
    flex-grow: 1;
    // font-size: 0.875rem;
    font-size: 1.5rem;
    font-weight: 500;
    padding: 0.125rem;
    opacity: 0.75;
    // background-color: lightslategray;
    // color: whitesmoke;
    border: none;

    width: 10px;
}
.single-line-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.WIDGET .widget-content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    flex: 1 1 auto;
    overflow: auto;
    height: 100%;
    border: none; /* разделитель под шапкой рисует только .widget-container */
}
.WIDGET .blank-WIDGET {
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.commandPanel-buttons {
    background-color: lightslategray;
}
.commandPanel {
    padding: 2px;
}
.wj-radialgauge {
    width: 60%;
    height: 60%;
    max-width: 300px;
    padding: 1rem;
    overflow: hidden;
}
.wj-radialgauge .wj-value {
    font-size: 0.75rem;
    font-weight: 500;
}
.wj-gauge .wj-face path {
    stroke: none;
}

.wj-flexchart {
    height: -webkit-fill-available;
    background: transparent;
    width: 100%;
    border: none;
    padding: 0rem;
    margin: 0;
    overflow: hidden;
}
.wj-ranges {
    opacity: 0.15;
}

h3 {
    font-size: 0.875rem;
    font-weight: 500;
    text-align: center;
}
h4 {
    font-size: 0.875rem;
    font-size: 0.75rem;
    font-weight: 400;
    min-width: 7rem;
}
.wj-lineargauge {
    max-height: 1rem;
    width: 100%;
    overflow: hidden;
}
.line-gauge-WIDGET {
    width: 100%;
    padding: 0 1rem;
}
.flex-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 1rem;
}
.wj-ranges {
    opacity: 0.15;
}

.wj-flexgrid {
    border: none;
    height: 100%;
}

.bulet-graph-WIDGET {
    width: 100%;
    padding: 0 1rem;
    overflow: hidden;
}
.table {
    margin: 0;
    table-layout: fixed;
    width: 100%;
}
.table td {
    padding: 0.15rem 0.5rem;
    font-size: 0.75rem;
    white-space: nowrap;
    width: 1.5rem;
}
.table td:first-child {
    width: 4rem;
}
.table td:last-child {
    width: auto;
}
/* IE 2026 09 23 / ODOO-… (замечание Игоря: панели-меню в Full screen): команда Full screen переводит в полноэкран весь документ (html), а не #app — иначе всё, что телепортировано в body
   (панели функций, форма ячейки, окна легенд, подсказки), браузер не рисует. Правила ниже — только для полноэкрана ВИДЖЕТА (Shift Alt F):
   у корня документа фон и панели wijmo остаются штатными */
:fullscreen:not(:root) {
   background-color: white;
}
:-webkit-full-screen:not(:root) {
   background-color: white;
}
:fullscreen:not(:root) .wj-dropdown-panel,
:-webkit-full-screen:not(:root) .wj-dropdown-panel {
    position: fixed !important;
    z-index: 3000 !important;
}

/* индикатор записи тестового сценария (testRecorder) — ниже тостов, всегда виден */
/* IE 2026 08 27 / ODOO-5800 (заказ Игоря): плашка устаревшей версии — сверху, по центру, между строкой чипсов
   и полем виджетов, поверх контента; размеры и форма как у прежнего нижнего сообщения (шапку не перекрывает) */
.update-banner {
    position: fixed;
    top: var(--update-banner-top, 52px);
    left: 50%;
    transform: translateX(-50%);
    z-index: 1003;
    display: flex;
    align-items: center;
    gap: 8px;
    max-width: calc(100vw - 2rem);
    background-color: #c62828;
    border: 1px solid #8e0000;
    border-radius: 0.5rem;
    padding: 6px 10px;
    color: #fff;
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
.update-banner-icon { color: #fff; }
.update-banner-text { font-size: 0.875rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.update-banner-btn {
    display: flex;
    align-items: center;
    border: 1px solid #fff;
    background: #fff;
    color: #b71c1c;
    border-radius: 0.35rem;
    padding: 3px 10px;
    font-size: 0.8125rem;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
}
.update-banner .btn-hover { color: #fff; }
.update-banner-btn:hover { filter: brightness(1.08); }

/* IE 2026 09 26 / ODOO-… (замечание Игоря: баннер предупреждения стола): предупреждение страницы — компактный баннер по центру под
   шапкой, форма как у плашки новой версии (.update-banner: скругление, отступы, тень, высота 36 px), палитра жёлтая — переменные --cs-warn-* (гамма может
   переопределить, как остальные --cs-*; контраст текста к фону ≥ 4.5 — замер пробой wsalert_check). Ряд — в потоке .topbar, как прежняя полоса: 4 px
   сверху и снизу, пустые края ряда клики не ловят */
:root {
    --cs-warn-bg: #ffd43b;
    --cs-warn-border: #e0a800;
    --cs-warn-fg: #3d3200;
    --cs-warn-icon: #6b5100;
    --cs-warn-hover: rgba(61, 50, 0, 0.12);
}
/* тёмная тема — filter: invert(1) на корне приложения: баннер инвертируется обратно (иначе жёлтый стал бы синим) и берёт тёмную янтарную палитру */
.dark-theme {
    --cs-warn-bg: #4a3b00;
    --cs-warn-border: #8f7200;
    --cs-warn-fg: #ffe38a;
    --cs-warn-icon: #ffd43b;
    --cs-warn-hover: rgba(255, 227, 138, 0.16);
}
.ws-alert-row {
    display: flex;
    justify-content: center;
    padding: 4px 1rem;
    pointer-events: none;
}
.ws-alert-banner {
    pointer-events: auto;
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    max-width: calc(100vw - 2rem);
    box-sizing: border-box;
    background-color: var(--cs-warn-bg);
    border: 1px solid var(--cs-warn-border);
    border-radius: 0.5rem;
    padding: 6px 6px 6px 10px;
    color: var(--cs-warn-fg);
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
.dark-theme .ws-alert-banner { filter: invert(1); }
/* тёмная тема: body (светлый) — вне инвертированного корня; прозрачный ряд показывал его светлой полосой во всю ширину — ряд цветом страницы,
   после инверсии тёмный, как шапка */
.dark-theme .ws-alert-row { background-color: var(--cs-page-bg, #f7faff); }
/* статусы ошибки — красным, как было у прежней полосы (бэк сейчас шлёт только warning) */
.ws-alert-banner.ws-alert-error,
.ws-alert-banner.ws-alert-critical {
    --cs-warn-bg: #ffc9c9; --cs-warn-border: #e03131; --cs-warn-fg: #5c0a0a; --cs-warn-icon: #c92a2a; --cs-warn-hover: rgba(92, 10, 10, 0.12);
}
.dark-theme .ws-alert-banner.ws-alert-error,
.dark-theme .ws-alert-banner.ws-alert-critical {
    --cs-warn-bg: #4d1515; --cs-warn-border: #a83232; --cs-warn-fg: #ffc9c9; --cs-warn-icon: #ff8787; --cs-warn-hover: rgba(255, 201, 201, 0.16);
}
.ws-alert-icon { color: var(--cs-warn-icon); flex: none; }
.ws-alert-text { font-size: 0.875rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 0; }
.ws-alert-close {
    flex: none;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    height: 22px;
    min-width: 24px;
    padding: 0 6px;
    border: 1px solid transparent;
    border-radius: 0.35rem;
    background: transparent;
    color: var(--cs-warn-fg);
    cursor: pointer;
}
.ws-alert-close .pi { font-size: 0.75rem; }
.ws-alert-close:hover { background: var(--cs-warn-hover); border-color: var(--cs-warn-border); }
.ws-alert-close:focus-visible { outline: 2px solid var(--cs-warn-border); outline-offset: 1px; }
/* IE 2026 09 27 / ODOO-… (заказ Игоря: Open task в баннере предупреждения стола): кнопка «Open task» — как «Reload» плашки новой версии:
   заливка цветом текста баннера, надпись — цветом его фона (контраст — как у текста баннера), высота как у ✕ — баннер не растёт; палитра — те же
   --cs-warn-* (тёмная тема и красный вариант статуса ошибки меняют её сами) */
.ws-alert-open {
    flex: none;
    display: flex;
    align-items: center;
    gap: 5px;
    box-sizing: border-box;
    height: 22px;
    padding: 0 9px;
    border: 1px solid var(--cs-warn-fg);
    border-radius: 0.35rem;
    background: var(--cs-warn-fg);
    color: var(--cs-warn-bg);
    font-size: 0.8125rem;
    font-weight: 600;
    white-space: nowrap;
    cursor: pointer;
}
.ws-alert-open .pi { font-size: 0.875rem; line-height: 1; }
.ws-alert-open:hover { opacity: 0.86; }
.ws-alert-open:focus-visible { outline: 2px solid var(--cs-warn-border); outline-offset: 1px; }

.rec-indicator {
    position: fixed;
    bottom: 6px;
    right: 30px;
    z-index: 1002;
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: #fff3f3;
    border: 1px solid #e5b3b3;
    border-radius: 0.5rem;
    padding: 6px 10px;
    color: #a33;
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
.rec-indicator .rec-dot {
    width: 10px; height: 10px; border-radius: 50%;
    background: #d33;
    animation: rec-blink 1.2s ease-in-out infinite;
}
@keyframes rec-blink { 0%,100% { opacity: 1; } 50% { opacity: 0.25; } }
.rec-indicator .rec-stop {
    display: flex; align-items: center;
    border: 1px solid #d99; border-radius: 0.4rem;
    background: #fff; color: #a33;
    padding: 2px 8px; cursor: pointer; font-size: 0.9em;
}
.rec-indicator .rec-stop:hover { background: #ffe9e9; }

/* IE 2026 09 11 / ODOO-335246 (Igor): панель пошаговой отладки каскада — внизу слева страницы */
.casc-debug {
    position: fixed;
    bottom: 6px;
    left: 30px;
    z-index: 1002;
    display: flex;
    align-items: center;
    gap: 10px;
    max-width: min(900px, calc(100vw - 60px));
    background-color: #eef4ff;
    border: 1px solid #b3c6e5;
    border-radius: 0.5rem;
    padding: 6px 10px;
    color: #234;
    font-size: 0.9em;
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
.casc-debug .casc-debug-run {
    display: flex; align-items: center; white-space: nowrap;
    border: 1px solid #7a9cd0; border-radius: 0.4rem;
    background: #fff; color: #234a7a;
    padding: 4px 10px; cursor: pointer; font-weight: 600;
}
.casc-debug .casc-debug-run:hover { background: #e3ecfb; }
.casc-debug .casc-debug-run:disabled { opacity: 0.6; cursor: default; }
.casc-debug .casc-debug-info { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.casc-debug .casc-debug-row { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.casc-debug .casc-debug-err { color: #a33; }
.casc-debug .casc-debug-link { color: #234a7a; text-decoration: underline dotted; cursor: pointer; }
.casc-debug .casc-debug-link:hover { color: #0b2f66; text-decoration: underline; }
.casc-debug .casc-debug-off {
    border: none; background: transparent; color: #567; cursor: pointer; padding: 2px 4px;
}
.casc-debug .casc-debug-off:hover { color: #a33; }

/* IE 2026 09 11 (Igor): зелёные/жёлтые сообщения виджета (обновление данных) затухают сами; ошибки остаются */
.notification-widget { transition: opacity 1.5s ease; }
.notification-widget.notification-fading { opacity: 0; }

/* IE 2026 08 23 / ODOO-5884 (заказ Игоря): ссылка в тосте */
.notification-link {
    color: #2a62d9;
    cursor: pointer;
    white-space: nowrap;
    text-decoration: underline;
    font-weight: 600;
}
.notification-link:hover {
    color: #1b45a8;
}
/* IE 2026 08 23 / ODOO-5884 (заказ Игоря): подтверждение с полем ввода (имя ветки) */
.confirm-input-box { min-width: 480px; max-width: 72vw; }
.confirm-input-message { color: #495057; margin-bottom: 14px; line-height: 1.4; }
.confirm-input-message { white-space: pre-line; max-height: 40vh; overflow: auto; }   /* IE 2026 11 03 / ODOO-5800 (ie-dm7 #128579: согласование правил MAP-*, этап C): список правил окна подтверждения — построчно */
.confirm-input-field { display: flex; flex-direction: column; gap: 5px; margin-bottom: 16px; }
.confirm-input-label { font-size: 0.85rem; color: #6c757d; }
.confirm-input-input { padding: 8px 10px; border: 1px solid #b9c8dd; border-radius: 5px; font-size: 1rem; }
.confirm-input-input:focus { outline: none; border-color: #647eff; box-shadow: 0 0 0 2px #647eff33; }
.confirm-input-actions { display: flex; justify-content: flex-end; gap: 10px; }
.confirm-input-options { display: flex; flex-direction: column; gap: 6px; margin: 10px 2px 2px; }
/* IE 2026 10 09 / ODOO-345618: обязательные поля окна подтверждения (confirm_input.required / optionsRequired) */
.confirm-input-req { color: #b3261e; }
.confirm-input-input.is-invalid { border-color: #b3261e; box-shadow: 0 0 0 2px #b3261e26; }
.confirm-input-options.is-invalid { outline: 1px solid #b3261e; outline-offset: 3px; border-radius: 4px; }
.confirm-input-err { color: #b3261e; font-size: 12px; margin: 8px 2px 0; }
.confirm-input-option { display: flex; align-items: center; gap: 8px; font-size: 13px; color: #333; cursor: pointer; }
.cinp-btn { padding: 7px 18px; border-radius: 5px; font-weight: 600; cursor: pointer; border: 1px solid transparent; transition: background-color .15s; }
.cinp-btn-no { background: transparent; color: #647eff; }
.cinp-btn-no:hover { background: #eef2ff; }
.cinp-btn-yes { background: #e24c4c; color: #fff; }
.cinp-btn-yes:hover { background: #cf3d3d; }
/* IE 2026 08 23 / ODOO-5884 (заказ Игоря): окно прогресса команды (как окно подтверждения, без кнопок) */
.progress-modal {
    position: fixed;
    inset: 0;
    z-index: 20000;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.4);
}
.progress-box {
    position: relative;
    overflow: hidden;
    padding: 24px 28px 18px 28px;
    border-radius: 6px;
    background: #fff;
    box-shadow: 0 6px 28px rgba(0, 0, 0, 0.25);
    min-width: 360px;
    max-width: 70vw;
}
.progress-header {
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: 14px;
}
.progress-loading-bar {
    position: absolute;
    top: 0;
    left: 0;
    height: 5px;
    width: 30%;
    border-radius: 0.5rem;
    background: #647eff;
    animation: progress-loading-slide 2.2s ease-in-out infinite;
}
@keyframes progress-loading-slide {
    0%   { left: -30%; }
    100% { left: 100%; }
}
.progress-text {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 1rem;
    color: #495057;
}
.progress-icon {
    font-size: 1.6rem;
    color: #647eff;
}
.progress-note {
    margin-top: 12px;
    font-size: 0.85rem;
    color: #647eff;
    font-weight: 600;
    letter-spacing: 0.02em;
}
.notification {
    position: fixed;
    bottom: 40px;
    right: 30px;
    background-color: #daecda;
    color: #778899;
    padding: 10px;
    border-radius: 0.5rem;
    opacity: 1;
    transition: opacity 1s ease-in-out;
    z-index: 1001;
    
    /*border: 1px solid #26852b;*/
    border: 1px solid rgba(0, 0, 0, .2);
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    word-break: break-word;

    display: flex;
    align-items: center;
}
.notification-widget {
    /* АН 2026 08 15 / ODOO-4997 (Игорь п.12): свободное сообщение ПОВЕРХ
       виджета (не расталкивает контент); вертикальная середина плашки — на
       нижней границе заголовка. 2.643rem = фактическая высота
       .widget-container (0.6rem паддингов + инпут заголовка) при root 14px —
       всё в rem, масштабируется вместе с зумом */
    position: absolute;
    top: 2.643rem;
    transform: translateY(-50%);
    /* IE 2026 08 18 / ODOO-5512 (заказ Игоря): плашка прижата к ЛЕВОМУ краю
       виджета с отступом 30px (раньше — к правому, минус 50px: перекрывала
       START/TEST/STOP в правой части шапки) */
    left: 30px;
    right: auto;
    max-width: calc(100% - 30px - 1rem);
    /* внутри виджета — поверх шапки и командных панелей (z:100);
       наружу не вылезает — .WIDGET изолирован (isolation: isolate) */
    z-index: 120;
    border-radius: 0.375rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
    /* МАКСИМАЛЬНО ужата по высоте (Игорь 15.08): без вертикальных паддингов,
       плотная строка; крестик — по центру высоты */
    padding: 0 1.9rem 0 1rem;
    line-height: 1.25;
    background-color: #daecda;
    color: #778899;
}
/* заголовок скрыт — верхняя граница плашки на пару пикселей ниже верха виджета */
.WIDGET.widget-hide-header .notification-widget {
    top: 2px;
    transform: none;
}
.notification-widget.notification-cleared {
    /* очищенная полоса (softClear): прозрачно-белая, не зелёная */
    background-color: rgba(255, 255, 255, 0.55);
}
.notification-close {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 8px;
    cursor: pointer;
    font-size: 12px;
    color: #999;
}
.notification-close:hover {
    color: #333;
}
.notification-header {
    font-style: italic;
    font-size: 0.5rem;
}
.notification-workspace {
    padding: 10px 20px;
    background-color: #daecda;
    color: #778899;
    width: -webkit-fill-available;
    line-height: 1.2em;
}
.notification-error {
    background-color: #ffcbc8;
}
.notification-critical {
    background-color: #ffcbc8;
}
.notification-warning {
    background-color: #fffbea;
}
/* IE 2026 11 02 / ODOO-349799 (toast-info): status 'info' — нейтрально-синий, не зелёный фон success */
.notification-info {
    background-color: #deebf7;
}
.notification-pending {
    background-color: #fff8b9;
}
/* IE 2026 08 26 / ODOO-5800 (заказ Игоря): полоса хода прогона над текстом тоста —
   та же семантика, что widget-loading-border виджета задачи (ширина = % выполнения) */
.notification-progress {
    position: absolute;
    top: 0;
    left: 10px;
    right: 10px;
    height: 4px;
    border-radius: 0 0 3px 3px;
    background-color: rgba(0, 0, 0, 0.08);
    overflow: hidden;
}
.notification-progress-bar {
    height: 100%;
    background-color: #26852b;
    transition: width 0.6s ease;
}
.notification-fade-out {
    opacity: 0;
}
.btn-hover:hover {
    color: #26852b;
}

/* IE 2026 10 30 / ODOO-345618 (apply_branch: conflict override dialog): список конфликтов в тексте диалога — переводы строк сохраняются */
.p-confirm-dialog-message { white-space: pre-line; }
.my-body {
    opacity: 0;
}
.no-scroll {
    overflow: hidden;
}
.dark-theme{
    filter: invert(1);
}

/* IE 2026 08 29 / ODOO-5828 (заказ Игоря): подсветка остальных вхождений выделенного текста
   (VS Code-стиль), CSS Custom Highlight API — DOM не трогаем (виртуализация wijmo).
   Тёмная тема у нас — filter: invert(1) на всё приложение, поэтому цвет берём умеренный:
   после инверсии он остаётся различимым и не спорит с системным выделением (его не
   перекрываем — сам выделенный фрагмент в подсветку не попадает).
   ::highlight() не поддерживает border/outline — «рамку» даёт подчёркивание. */
::highlight(sel-match) {
    background-color: rgba(255, 190, 60, .40);
    text-decoration: underline 1px rgba(140, 90, 0, .55);
}
/* IE 2026 09 18 / ODOO-… (замечание Игоря): «продолжение» обрезанного текста при наведении (src/utils/clipOverlay.js —
   ячейки и заголовки грида, строки форм чипсов). Фон, цвет и шрифт слой берёт у самого элемента, текст ставится по замеру
   первой буквы — поэтому часть поверх элемента совпадает с ним пиксель в пиксель. Рамка — тенью: border сдвигал бы текст */
.clip-overlay {
    position: fixed;
    z-index: 99998;
    pointer-events: none;
    display: flex;
    align-items: center;
    white-space: nowrap;
    box-sizing: border-box;
    margin: 0;
    /* без скругления: скруглённые углы вместе с нижней линией строки делают слой «не сплошным», и браузер переводит его
       текст с субпиксельного (LCD) сглаживания на серое (замер tools/probes/lcd_diag.mjs) */
    border-radius: 0;
}
/* элемент сам живёт во всплывающем слое с тенью (форма чипса): его текст браузер сглаживает серым — оверлею нужно то же,
   поэтому рамка и тень остаются на текстовом слое */
.clip-overlay.clip-overlay-gray {
    box-shadow: 0 0 0 1px rgba(60, 72, 88, .22), 0 2px 8px rgba(0, 0, 0, .22);
}
/* рамка и тень «продолжения» — отдельным слоем под текстовым: внешняя тень на слое с текстом выключает субпиксельное
   сглаживание букв (текст поверх элемента переставал совпадать с ним по краям букв) */
.clip-overlay-shadow {
    position: fixed;
    z-index: 99997;
    pointer-events: none;
    box-sizing: border-box;
    margin: 0;
    border-radius: 0 2px 2px 0;
    box-shadow: 0 0 0 1px rgba(60, 72, 88, .22), 0 2px 8px rgba(0, 0, 0, .22);
}
/* IE 2026 09 17 / ODOO-… (заказ Игоря): выделена ЯЧЕЙКА грида — в остальных ячейках с тем же текстом подсвечивается
   их текст (AttrGrid.sameValue_*), теми же цветами, что подсветка вхождений выделенного текста */
::highlight(cell-match) {
    background-color: rgba(255, 190, 60, .40);
    text-decoration: underline 1px rgba(140, 90, 0, .55);
}
/* IE 2026 09 20 / ODOO-5800 (Igor: переходы чипса метрик по ячейкам, подсветка параметра ячейки и подпадающих ячеек по наведению на чипс):
   metric-hit — значение каждой видимой ячейки, подпадающей под чипс (пока курсор над чипсом); metric-hit-cur — значение ячейки текущей остановки ‹ › */
::highlight(metric-hit) {
    background-color: rgba(110, 180, 255, .45);
    text-decoration: underline 1px rgba(20, 90, 170, .65);
}
::highlight(metric-hit-cur) {
    background-color: rgba(40, 120, 235, .92);
    color: #fff;
}
/* ячейка без значения (метрика «поле не заполнено» метит пустые ячейки) — рамка самой ячейки вместо подсветки текста */
.wj-cell.metric-hit-cell { box-shadow: inset 0 0 0 2px rgba(110, 180, 255, .9) !important; }
.wj-cell.metric-hit-cur-cell { box-shadow: inset 0 0 0 2px rgba(40, 120, 235, 1) !important; }
.p-button-no-border {
    border-color: transparent;
}
.p-button-border {
    border-color: lightgrey;
}
/* IE 2026 08 23 / ODOO-336291 (mobile UX), скрин Игоря (Branch · Statistics): ховер-акцент
   кнопок — только устройствам с курсором. На таче :hover «залипает» после тапа
   (iOS Safari), и кнопка командной панели оставалась оранжевой/жирной с серой рамкой. */
@media (hover: hover) {
    .p-button:enabled:hover {
        /* IE 2026 09 29 / ODOO-… (заказ Игоря: ширина кнопки при наведении): «жирность на вид» — обводкой букв цветом текста, а не font-weight: bolder —
           жирное начертание шире, кнопка с текстом раздавалась и соседи ряда съезжали (0.028em ≈ bold по «чернилам», замер p225) */
        -webkit-text-stroke: 0.028em currentColor;
        border-color: lightgray;
        color: rgba(255, 150, 30, .75) !important;
        /*border-style: dashed;*/
    }
}

.Attr {
    font-stretch: ultra-condensed;
    color: white;
    background: lightslategray;
    border-radius: 3px;
    padding-inline: 0.3rem;
    opacity: 0.75;
}
/* короткий чипс типа (одна буква) в ячейках шаблона печати */
.chip-short {
    display: inline-block;
    min-width: 1.1em;
    text-align: center;
}
.AttrTab {
    font-stretch: ultra-condensed;
    color: white;
    background: lightslategray;
    border-radius: 3px;
    padding-inline: 0.3rem;
    opacity: 0.75;
}
.AttrTabGrid {
    font-stretch: ultra-condensed;
    color: white;
    background: lightslategray;
    border-radius: 3px;
    padding-inline: 0.3rem;
    opacity: 0.75;
}
.AttrGrid {
    font-stretch: ultra-condensed;
    color: white;
    background: #12826c;
    border-radius: 3px;
    padding-inline: 0.3rem;
    opacity: 0.75;
}
.AttrButton {
    font-stretch: ultra-condensed;
    color: white;
    background: #8ea0ff;
    border-radius: 3px;
    padding-inline: 0.3rem;
    opacity: 0.75;
}
.field-tooltip {
    font-stretch: ultra-condensed;
    color: white;
    background: lightslategray;
    border-radius: 3px;
    padding-inline: 0.3rem;
    opacity: 0.75;
}
/* строка меню — всегда целиком */
.wj-listbox-item {
    padding: 0 !important;
}

/* твоя разметка */
.wj-menu-item-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 6px 10px;
}

/* хоткей */
.wj-menu-item-hotkey {
    font-stretch: ultra-condensed;
    padding-left: 3px;
    opacity: 0.6;
    font-family: monospace;
}
/* IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов): пока снимается картинка виджета (html2canvas — одна длинная задача главного потока) — курсор «идёт работа» */
body.preview-capturing, body.preview-capturing * { cursor: progress !important; }
</style>
